/* eslint-disable no-nested-ternary */
import * as Yup from 'yup';
import { iAddress, iAttachments, iContactMin, iFVSCheckboxAll, iFormMetaData, iObligation, iSummary, iSummaryField, tileReview } from '@interfaces/interfaces';
import { ProgressStep, FormType, ABN_MIN_LENGTH, ACN_MIN_LENGTH } from '@constants';
import { ADDRESS_FIELD_CHARS_REGEX, COMPANY_NAME_REGEX, CONTACT_NUMBER_REGEX, EMAIL_SPECIAL_CHARS_REGEX, FREE_TEXT_FIELD_REGEX, NAMES_FIELDS_REGEX, OBLIGATION_REGEX, POSITION_IN_COMPANY_REGEX, POST_CODE_REGEX, VEHICLE_REGISTRATION_REGEX } from '@services/ValidationRules';

import { FormikValues } from 'formik';
import { CONFIRM_AUTHORISED, EMPTY_DATE, FILE_UPLOAD_FAIL, INVALID_ABN, INVALID_ACN, INVALID_ADDRESS_FIELD_ERROR, INVALID_COMPANY_NAME, INVALID_EMAIL, INVALID_FREE_TEXT_FIELD_FORMAT, INVALID_FUTURE_DATE, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION, INVALID_INPUT_LONGER_THAN_10_CHARS, INVALID_INPUT_LONGER_THAN_15_CHARS, INVALID_INPUT_LONGER_THAN_200_CHARS, INVALID_INPUT_LONGER_THAN_25_CHARS, INVALID_INPUT_LONGER_THAN_50_CHARS, INVALID_INPUT_LONGER_THAN_75_CHARS, INVALID_INPUT_LONGER_THAN_80_CHARS, INVALID_LICENCE_FORMAT_NOMINATION, INVALID_MOBILE_NUMBER_FORMAT, INVALID_NAME_FORMAT_NEW, INVALID_NUMERIC_FORMAT, INVALID_OBLIGATION_NUMBER, INVALID_PHONE_NUMBER, INVALID_PHONE_NUMBER_LENGTH, INVALID_PHONE_NUMBER_LENGTH_15, INVALID_POSITION_IN_COMPANY_FIELD, INVALID_POST_CODE, INVALID_VEHICLE_REGISTRATION_NUMBER, INVALID_YESNO_FORMAT, MISSING_DECLARATION_AGREEMENT } from './ErrorMessages';
import keys from './PageValidationKeys';
import { reviewInfoDisplayObject } from './FormFieldConfig';

const { REVIEW } = FormType;

// const today = new Date();
export interface iPartialFormData {
  a: string;
  submitted: boolean;
  CheckAndConfirmPageLoaded: boolean;
  // Step1 Field
  // Step2 Fields
  OFFENCE_DATE: Date | null;
  HEARING_DATE: Date | null;
  VEHICLE_REGISTRATION: string;
  DRIVER_LICENCE: string;
  DOB: Date | null;
  ObligationStatus: string;
  isNominatable: boolean | null;
  CanSave: boolean | null;
  isDebtorTypeIndividual: boolean | null;
  isDebtorTypeCompany: boolean | null;
  isInternalReviewStage: boolean | null;
  isEnforcementReviewStage: boolean | null;
  Status: string;
  DebtorType: string;
  isPUEligible: boolean | null;
  // Step 3
  WasSomeoneElseDrivingAtTimeOfOffence: string;
  ApplyingForPenaltyReminder: string;
  HaveYouSubmittedEnforcementReviewBefore: string;
  // Step 4
  SaveYesNo: string;
  SaveOptions: string;
  saveEmail: string;
  saveMobile: string;
  // Step 5
  isThePersonNamed: string;
  isThirdPartyAuthorised: boolean;
  // Step 6 - General
  selectTheOption: string[];
  reviewGroundsList: tileReview[];
  // Step 6 - Contrary to Law
  contraryToLawWasLegalMistakeMade: string;
  contraryToLawCanUploadSupportingDocs: string;
  // Step 6 - Exceptional Circumstances
  wereThereExceptionalCircumstances: string;
  exceptionalsCanUploadSupportingDocs: string;
  // Step 6 - Mistake of Identity
  wasThereAnIdentificationMistake: string;
  mistakeOfIdentityCanUploadSupportingDocs: string;
  mistakeOfIndentityWasSomeoneElseDriving: string;
  // Step 6 - Person Unaware
  personUnawareFindOutDate: Date | null;
  personUnawareCanUploadSupportingDocs: string;
  personUnawareEnforcementHappened: string;
  personUnawareWasSomeoneElseDriving: string;
  // Step 6 - Special Circumstances
  wereThereSpecialCircumstances: string;
  specialsCanUploadSupportingDocs: string;
  // Step 7
  WhyYourFineShouldBeReviewed: string;
  HasStatementAndEvidenceSupportingDocs: string;

  StatementAndEvidenceNameField: string;
  StatementAndEvidence: iAttachments[];
  StatementAndEvidenceProvider: string;
  StatementAndEvidenceDescription: string;
  StatementAndEvidenceSizeErrorHandle: string;
  StatementAndEvidenceFileUploadErrorHandle: string;
  StatementAndEvidenceFileSectionError: string;
  FileUploadSizeConfig: number;
  FileUploadMaxAttachmentsConfig: number;

  IsMakingTimeRequest: string;
  TimeExtension: string;
  // Step 8 - General
  selectTheSpecialOption: string[];
  // Step 9
  GivenNamesFineholderDetails: string;
  FamilyNameFineholderDetails: string;
  DOBFineholderDetails: Date | null;
  PlaceOfIssueFineholderDetails: string;
  StateOfIssueFineholderDetails: string;
  YesNoDriverLicenceFineholderDetails: boolean;
  PostalAddressFineholderDetails: iAddress;
  DifferentToPostalFineholderDetails: string;
  ResidentialAddressFineholderDetails: iAddress;
  ContactNumberFineholderDetails: iContactMin;
  ContactNumberFineholderDetailsMessage: string;
  EmailFineholderDetails: string;
  EmailFineholderDetailsMessage: string;
  YesNoEmailFineholderDetails: boolean;
  // Step 10 Individual
  GivenNamesYourDetailsIndividual: string;
  FamilyNameYourDetailsIndividual: string;
  DOBYourDetailsIndividual: Date | null;
  PlaceOfIssueYourDetailsIndividual: string;
  StateOfIssueYourDetailsIndividual: string;
  YesNoDriverLicenceYourDetailsIndividual: boolean;
  PostalAddressYourDetailsIndividual: iAddress;
  DifferentToPostalYourDetailsIndividual: string;
  ResidentialAddressYourDetailsIndividual: iAddress;
  ContactNumberYourDetailsIndividual: iContactMin;
  EmailYourDetailsIndividual: string;
  YesNoEmailYourDetailsIndividual: boolean;
  ReceiveApplicationViaEmailYourDetailsIndividual: string;
  ReceiveCorrespondenceViaEmailYourDetailsIndividual: string;
  ContactNumberYourDetailsIndividualWarning: string;
  EmailYourDetailsIndividualWarning: string;
  // Step 10 Third Party
  GivenNamesYourDetailsThirdParty: string;
  FamilyNameYourDetailsThirdParty: string;
  RelationshipWithNamedPersonYourDetailsThirdParty: string;
  OrganisationNameYourDetailsThirdParty: string;
  PostalAddressYourDetailsThirdParty: iAddress;
  ContactNumberYourDetailsThirdParty: iContactMin;
  EmailYourDetailsThirdParty: string;
  YesNoEmailYourDetailsThirdParty: boolean;
  ReceiveApplicationViaEmailYourDetailsThirdParty: string;
  CorrespondenceRecipientYourDetailsThirdParty: string;
  ContactNumberYourDetailsThirdPartyWarning: string;
  EmailYourDetailsThirdPartyWarning: string;
  // Step 10 Company
  GivenNamesYourDetailsCompany: string;
  FamilyNameYourDetailsCompany: string;
  PositionInCompanyYourDetailsCompany: string;
  CompanyNameYourDetailsCompany: string;
  AbnAcnTypeYourDetailsCompany: string;
  ABNYourDetailsCompany: string;
  isABNValidYourDetails: boolean;
  isACNValidYourDetails: boolean;
  ACNYourDetailsCompany: string;
  PostalAddressYourDetailsCompany: iAddress;
  DifferentToPostalYourDetailsCompany: string;
  StreetAddressYourDetailsCompany: iAddress;
  ContactNumberYourDetailsCompany: iContactMin;
  EmailYourDetailsCompany: string;
  YesNoEmailYourDetailsCompany: boolean;
  ContactNumberYourDetailsCompanyWarning: string;
  EmailYourDetailsCompanyWarning: string;
   // Step 11 and 12
   AuthorisedObligation: iObligation;
   EligibleObligations: iObligation[];
   // Step 11
   SelectedObligationsStep11: iFVSCheckboxAll[];
   // Step 12
   areThereAnyAdditionalFines: string;
   obligationNumberToIncludeStep12: string;
   SelectedObligationsStep12: string[];
  // Step 14
  ReviewConsentToDeclaration: boolean;
}
interface iPartialFormObligations {
  ID: number;
  ObligationNO: string;
  IsPrimary: boolean;
}
export interface iCommonReviewValues {
  [key: string]: string | Date | boolean | number | iAttachments[] | iAddress | iContactMin | iPartialFormObligations[] | iPartialFormData | null | iFVSCheckboxAll[] | string[] | iObligation | iObligation[] | tileReview[];
  OBLIGATION_NUMBER: string;
  // Step 2
  OFFENCE_DATE: Date | null;
  HEARING_DATE: Date | null;
  VEHICLE_REGISTRATION: string;
  DRIVER_LICENCE: string;
  DOB: Date | null;
  // Partial Forms
  ID: string;
  PartialFormID: string;
  FormData: iPartialFormData;
  Obligations: iPartialFormObligations[];
}

export interface iReviewFormValues extends iCommonReviewValues {
  InfringementNumber: string;
  CheckAndConfirmPageLoaded: boolean;

  ObligationStatus: string;
  isNominatable: boolean | null;
  CanSave: boolean | null;
  isDebtorTypeIndividual: boolean | null;
  isDebtorTypeCompany: boolean | null;
  isInternalReviewStage: boolean | null;
  isEnforcementReviewStage: boolean | null;
  Status: string;
  DebtorType: string;
  isPUEligible: boolean | null;
  // Step 3
  WasSomeoneElseDrivingAtTimeOfOffence: string;
  ApplyingForPenaltyReminder: string;
  HaveYouSubmittedEnforcementReviewBefore: string;
  // Step 4
  SaveYesNo: string;
  SaveOptions: string;
  saveEmail: string;
  saveMobile: string;
  IsSubscribedEM: boolean;
  IsSubscribedSMS: boolean;
  EMRemeinderSent: boolean;
  SMSRemeinderSent: boolean;
  // Step 6 - General
  selectTheOption: string[];
  reviewGroundsList: tileReview[];
  // Step 6 - Contrary to Law
  contraryToLawWasLegalMistakeMade: string;
  contraryToLawCanUploadSupportingDocs: string;
  // Step 6 - Exceptional Circumstances
  wereThereExceptionalCircumstances: string;
  exceptionalsCanUploadSupportingDocs: string;
  // Step 6 - Mistake of Identity
  wasThereAnIdentificationMistake: string;
  mistakeOfIdentityCanUploadSupportingDocs: string;
  mistakeOfIndentityWasSomeoneElseDriving: string;
  // Step 6 - Person Unaware
  personUnawareFindOutDate: Date | null;
  personUnawareCanUploadSupportingDocs: string;
  personUnawareEnforcementHappened: string;
  personUnawareWasSomeoneElseDriving: string;
  // Step 6 - Special Circumstances
  wereThereSpecialCircumstances: string;
  specialsCanUploadSupportingDocs: string;
  // Step 5
  isThePersonNamed: string;
  isThirdPartyAuthorised: boolean;
  // Step 7
  WhyYourFineShouldBeReviewed: string;
  HasStatementAndEvidenceSupportingDocs: string;

  StatementAndEvidenceNameField: string;
  StatementAndEvidence: iAttachments[];
  StatementAndEvidenceProvider: string;
  StatementAndEvidenceDescription: string;
  StatementAndEvidenceSizeErrorHandle: string;
  StatementAndEvidenceFileUploadErrorHandle: string;
  StatementAndEvidenceFileSectionError: string;
  FileUploadSizeConfig: number;
  FileUploadMaxAttachmentsConfig: number;

  IsMakingTimeRequest: string;
  TimeExtension: string;
  // Step 8 - General
  selectTheSpecialOption: string[];
  // Step 9
  GivenNamesFineholderDetails: string;
  FamilyNameFineholderDetails: string;
  DOBFineholderDetails: Date | null;
  PlaceOfIssueFineholderDetails: string;
  StateOfIssueFineholderDetails: string;
  YesNoDriverLicenceFineholderDetails: boolean;
  PostalAddressFineholderDetails: iAddress;
  DifferentToPostalFineholderDetails: string;
  ResidentialAddressFineholderDetails: iAddress;
  ContactNumberFineholderDetails: iContactMin;
  ContactNumberFineholderDetailsMessage: string;
  EmailFineholderDetails: string;
  EmailFineholderDetailsMessage: string;
  YesNoEmailFineholderDetails: boolean;
  // Step 10 Individual
  GivenNamesYourDetailsIndividual: string;
  FamilyNameYourDetailsIndividual: string;
  DOBYourDetailsIndividual: Date | null;
  PlaceOfIssueYourDetailsIndividual: string;
  StateOfIssueYourDetailsIndividual: string;
  YesNoDriverLicenceYourDetailsIndividual: boolean;
  PostalAddressYourDetailsIndividual: iAddress;
  DifferentToPostalYourDetailsIndividual: string;
  ResidentialAddressYourDetailsIndividual: iAddress;
  ContactNumberYourDetailsIndividual: iContactMin;
  EmailYourDetailsIndividual: string;
  YesNoEmailYourDetailsIndividual: boolean;
  ReceiveApplicationViaEmailYourDetailsIndividual: string;
  ReceiveCorrespondenceViaEmailYourDetailsIndividual: string;
  ContactNumberYourDetailsIndividualWarning: string;
  EmailYourDetailsIndividualWarning: string;
  // Step 10 Third Party
  GivenNamesYourDetailsThirdParty: string;
  FamilyNameYourDetailsThirdParty: string;
  RelationshipWithNamedPersonYourDetailsThirdParty: string;
  OrganisationNameYourDetailsThirdParty: string;
  PostalAddressYourDetailsThirdParty: iAddress;
  ContactNumberYourDetailsThirdParty: iContactMin;
  EmailYourDetailsThirdParty: string;
  YesNoEmailYourDetailsThirdParty: boolean;
  ReceiveApplicationViaEmailYourDetailsThirdParty: string;
  CorrespondenceRecipientYourDetailsThirdParty: string;
  ContactNumberYourDetailsThirdPartyWarning: string;
  EmailYourDetailsThirdPartyWarning: string;
  // Step 10 Company
  GivenNamesYourDetailsCompany: string;
  FamilyNameYourDetailsCompany: string;
  PositionInCompanyYourDetailsCompany: string;
  CompanyNameYourDetailsCompany: string;
  AbnAcnTypeYourDetailsCompany: string;
  ABNYourDetailsCompany: string;
  ACNYourDetailsCompany: string;
  isABNValidYourDetails: boolean;
  isACNValidYourDetails: boolean;
  PostalAddressYourDetailsCompany: iAddress;
  DifferentToPostalYourDetailsCompany: string;
  StreetAddressYourDetailsCompany: iAddress;
  ContactNumberYourDetailsCompany: iContactMin;
  EmailYourDetailsCompany: string;
  YesNoEmailYourDetailsCompany: boolean;
  ContactNumberYourDetailsCompanyWarning: string;
  EmailYourDetailsCompanyWarning: string;
  // Step 11 and 12
  AuthorisedObligation: iObligation;
  EligibleObligations: iObligation[];
  // Step 11
  SelectedObligationsStep11: iFVSCheckboxAll[];
  PersonUnawareIneligibleList: iObligation[];
  NumberOfValidEnforcementReview: number;
  NumberOfValidInternalReview: number;
  NumberOfInvalidSevenDayNotice: number;
  // Step 12
  areThereAnyAdditionalFines: string;
  obligationNumberToIncludeStep12: string;
  SelectedObligationsStep12: string[];
  // Step 14
  ReviewConsentToDeclaration: boolean;
  // Step 15
  FormExperience: string;
  // Submission Error
  // submission error message
  submissionError: string;
}

export const defaultForm = (): iReviewFormValues => {
  const defaultValues: iReviewFormValues = {
    OBLIGATION_NUMBER: '',
    InfringementNumber: '',
    CheckAndConfirmPageLoaded: false,

    ObligationStatus: '',
    isNominatable: null,
    CanSave: null,
    isDebtorTypeIndividual: null,
    isDebtorTypeCompany: null,
    isInternalReviewStage: null,
    isEnforcementReviewStage: null,
    Status: '',
    DebtorType: '',
    isPUEligible: null,
    // Step 2
    OFFENCE_DATE: null,
    HEARING_DATE: null,
    DRIVER_LICENCE: '',
    VEHICLE_REGISTRATION: '',
    DOB: null,
    // Step 3
    WasSomeoneElseDrivingAtTimeOfOffence: '',
    ApplyingForPenaltyReminder: '',
    HaveYouSubmittedEnforcementReviewBefore: '',
    // Step 4
    SaveYesNo: '',
    SaveOptions: '',
    saveEmail: '',
    saveMobile: '',
    IsSubscribedEM: false,
    IsSubscribedSMS: false,
    EMRemeinderSent: false,
    SMSRemeinderSent: false,
    // Step 5
    isThePersonNamed: '',
    isThirdPartyAuthorised: false,
    // Step 6 - General
    selectTheOption: [],
    reviewGroundsList: [],
    // Step 6 - Contrary to Law
    contraryToLawWasLegalMistakeMade: '',
    contraryToLawCanUploadSupportingDocs: '',
    // Step 6 - Exceptional Circumstances
    wereThereExceptionalCircumstances: '',
    exceptionalsCanUploadSupportingDocs: '',
    // Step 6 - Mistake of Identity
    wasThereAnIdentificationMistake: '',
    mistakeOfIdentityCanUploadSupportingDocs: '',
    mistakeOfIndentityWasSomeoneElseDriving: '',
    // Step 6 - Person Unaware
    personUnawareFindOutDate: null,
    personUnawareCanUploadSupportingDocs: '',
    personUnawareEnforcementHappened: '',
    personUnawareWasSomeoneElseDriving: '',
    // Step 6 - Special Circumstances
    wereThereSpecialCircumstances: '',
    specialsCanUploadSupportingDocs: '',
    // Step 7
    WhyYourFineShouldBeReviewed: '',
    HasStatementAndEvidenceSupportingDocs: '',

    StatementAndEvidenceNameField: '',
    StatementAndEvidence: [],
    StatementAndEvidenceProvider: '',
    StatementAndEvidenceDescription: '',
    StatementAndEvidenceSizeErrorHandle: '',
    StatementAndEvidenceFileUploadErrorHandle: '',
    StatementAndEvidenceFileSectionError: '',
    FileUploadSizeConfig: 0,
    FileUploadMaxAttachmentsConfig: 0,

    IsMakingTimeRequest: '',
    TimeExtension: '',
    // Step 8
    selectTheSpecialOption: [],
    // Step 9
    GivenNamesFineholderDetails: '',
    FamilyNameFineholderDetails: '',
    DOBFineholderDetails: null,
    PlaceOfIssueFineholderDetails: 'Australia',
    StateOfIssueFineholderDetails: '',
    YesNoDriverLicenceFineholderDetails: false,
    PostalAddressFineholderDetails: {
      SearchText: '',
      Address: '',
      LineOne: '',
      LineTwo: '',
      Suburb: '',
      State: '',
      Postcode: '',
      Country: 'Australia',
    },
    DifferentToPostalFineholderDetails: '',
    ResidentialAddressFineholderDetails: {
      SearchText: '',
      Address: '',
      LineOne: '',
      LineTwo: '',
      Suburb: '',
      State: '',
      Postcode: '',
      Country: 'Australia',
    },
    ContactNumberFineholderDetails: {
      ContactNumber: '',
    },
    ContactNumberFineholderDetailsMessage: '',
    EmailFineholderDetails: '',
    EmailFineholderDetailsMessage: '',
    YesNoEmailFineholderDetails: false,
    // Step 10 Individual
    GivenNamesYourDetailsIndividual: '',
    FamilyNameYourDetailsIndividual: '',
    DOBYourDetailsIndividual: null,
    PlaceOfIssueYourDetailsIndividual: 'Australia',
    StateOfIssueYourDetailsIndividual: '',
    YesNoDriverLicenceYourDetailsIndividual: false,
    PostalAddressYourDetailsIndividual: {
      SearchText: '',
      Address: '',
      LineOne: '',
      LineTwo: '',
      Suburb: '',
      State: '',
      Postcode: '',
      Country: 'Australia',
    },
    DifferentToPostalYourDetailsIndividual: '',
    ResidentialAddressYourDetailsIndividual: {
      SearchText: '',
      Address: '',
      LineOne: '',
      LineTwo: '',
      Suburb: '',
      State: '',
      Postcode: '',
      Country: 'Australia',
    },
    ContactNumberYourDetailsIndividual: {
      ContactNumber: '',
    },
    EmailYourDetailsIndividual: '',
    YesNoEmailYourDetailsIndividual: false,
    ReceiveApplicationViaEmailYourDetailsIndividual: '',
    ReceiveCorrespondenceViaEmailYourDetailsIndividual: '',
    ContactNumberYourDetailsIndividualWarning: '',
    EmailYourDetailsIndividualWarning: '',
    // Step 10 Third Party
    GivenNamesYourDetailsThirdParty: '',
    FamilyNameYourDetailsThirdParty: '',
    RelationshipWithNamedPersonYourDetailsThirdParty: '',
    OrganisationNameYourDetailsThirdParty: '',
    PostalAddressYourDetailsThirdParty: {
      SearchText: '',
      Address: '',
      LineOne: '',
      LineTwo: '',
      Suburb: '',
      State: '',
      Postcode: '',
      Country: 'Australia',
    },
    ContactNumberYourDetailsThirdParty: {
      ContactNumber: '',
    },
    EmailYourDetailsThirdParty: '',
    YesNoEmailYourDetailsThirdParty: false,
    ReceiveApplicationViaEmailYourDetailsThirdParty: '',
    CorrespondenceRecipientYourDetailsThirdParty: '',
    ContactNumberYourDetailsThirdPartyWarning: '',
    EmailYourDetailsThirdPartyWarning: '',
    // Step 10 Company
    GivenNamesYourDetailsCompany: '',
    FamilyNameYourDetailsCompany: '',
    PositionInCompanyYourDetailsCompany: '',
    CompanyNameYourDetailsCompany: '',
    AbnAcnTypeYourDetailsCompany: '',
    ABNYourDetailsCompany: '',
    ACNYourDetailsCompany: '',
    isABNValidYourDetails: false,
    isACNValidYourDetails: false,
    PostalAddressYourDetailsCompany: {
      SearchText: '',
      Address: '',
      LineOne: '',
      LineTwo: '',
      Suburb: '',
      State: '',
      Postcode: '',
      Country: 'Australia',
    },
    DifferentToPostalYourDetailsCompany: '',
    StreetAddressYourDetailsCompany: {
      SearchText: '',
      Address: '',
      LineOne: '',
      LineTwo: '',
      Suburb: '',
      State: '',
      Postcode: '',
      Country: 'Australia',
    },
    ContactNumberYourDetailsCompany: {
      ContactNumber: '',
    },
    EmailYourDetailsCompany: '',
    YesNoEmailYourDetailsCompany: false,
    ContactNumberYourDetailsCompanyWarning: '',
    EmailYourDetailsCompanyWarning: '',
    // Step 11 and 12
    AuthorisedObligation: {} as iObligation,
    EligibleObligations: [],
    // Step 11
    SelectedObligationsStep11: [],
    PersonUnawareIneligibleList: [],
    NumberOfValidEnforcementReview: 0,
    NumberOfValidInternalReview: 0,
    NumberOfInvalidSevenDayNotice: 0,
    // Step 12
    areThereAnyAdditionalFines: '',
    obligationNumberToIncludeStep12: '',
    SelectedObligationsStep12: [],
    // Step 14
  ReviewConsentToDeclaration: false,

  // Step 15
  FormExperience: '',
  // Submission Error
  submissionError: '',

    // Partial Forms
    ID: '',
    PartialFormID: '',
    Obligations: [],
    FormData: {
      a: '',
      // is submitted
      CheckAndConfirmPageLoaded: false,
      submitted: false,
      ObligationStatus: '',
      isNominatable: null,
      CanSave: null,
      isDebtorTypeIndividual: null,
      isDebtorTypeCompany: null,
      isInternalReviewStage: null,
      isEnforcementReviewStage: null,
      Status: '',
      DebtorType: '',
      isPUEligible: null,
      // Step 2
      OFFENCE_DATE: null,
      HEARING_DATE: null,
      DRIVER_LICENCE: '',
      VEHICLE_REGISTRATION: '',
      DOB: null,
      // Step 3
      WasSomeoneElseDrivingAtTimeOfOffence: '',
      ApplyingForPenaltyReminder: '',
      HaveYouSubmittedEnforcementReviewBefore: '',
      // Step 4
      SaveYesNo: '',
      SaveOptions: '',
      saveEmail: '',
      saveMobile: '',
      // Step 5
      isThePersonNamed: '',
      isThirdPartyAuthorised: false,
      // Step 6 - General
      selectTheOption: [],
      reviewGroundsList: [],
      // Step 6 - Contrary to Law
      contraryToLawWasLegalMistakeMade: '',
      contraryToLawCanUploadSupportingDocs: '',
      // Step 6 - Exceptional Circumstances
      wereThereExceptionalCircumstances: '',
      exceptionalsCanUploadSupportingDocs: '',
      // Step 6 - Mistake of Identity
      wasThereAnIdentificationMistake: '',
      mistakeOfIdentityCanUploadSupportingDocs: '',
      mistakeOfIndentityWasSomeoneElseDriving: '',
      // Step 6 - Person Unaware
      personUnawareFindOutDate: null,
      personUnawareCanUploadSupportingDocs: '',
      personUnawareEnforcementHappened: '',
      personUnawareWasSomeoneElseDriving: '',
      // Step 6 - Special Circumstances
      wereThereSpecialCircumstances: '',
      specialsCanUploadSupportingDocs: '',
      // Step 7
      WhyYourFineShouldBeReviewed: '',
      HasStatementAndEvidenceSupportingDocs: '',

      StatementAndEvidenceNameField: '',
      StatementAndEvidence: [],
      StatementAndEvidenceProvider: '',
      StatementAndEvidenceDescription: '',
      StatementAndEvidenceSizeErrorHandle: '',
      StatementAndEvidenceFileUploadErrorHandle: '',
      StatementAndEvidenceFileSectionError: '',
      FileUploadSizeConfig: 0,
      FileUploadMaxAttachmentsConfig: 0,

      IsMakingTimeRequest: '',
      TimeExtension: '',
      // Step 8 - General
      selectTheSpecialOption: [],
      // Step 9
      GivenNamesFineholderDetails: '',
      FamilyNameFineholderDetails: '',
      DOBFineholderDetails: null,
      PlaceOfIssueFineholderDetails: 'Australia',
      StateOfIssueFineholderDetails: '',
      YesNoDriverLicenceFineholderDetails: false,
      PostalAddressFineholderDetails: {
        SearchText: '',
        Address: '',
        LineOne: '',
        LineTwo: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      },
      DifferentToPostalFineholderDetails: '',
      ResidentialAddressFineholderDetails: {
        SearchText: '',
        Address: '',
        LineOne: '',
        LineTwo: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      },
      ContactNumberFineholderDetails: {
        ContactNumber: '',
      },
      ContactNumberFineholderDetailsMessage: '',
      EmailFineholderDetails: '',
      EmailFineholderDetailsMessage: '',
      YesNoEmailFineholderDetails: false,
      // Step 10 Individual
      GivenNamesYourDetailsIndividual: '',
      FamilyNameYourDetailsIndividual: '',
      DOBYourDetailsIndividual: null,
      PlaceOfIssueYourDetailsIndividual: 'Australia',
      StateOfIssueYourDetailsIndividual: '',
      YesNoDriverLicenceYourDetailsIndividual: false,
      PostalAddressYourDetailsIndividual: {
        SearchText: '',
        Address: '',
        LineOne: '',
        LineTwo: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      },
      DifferentToPostalYourDetailsIndividual: '',
      ResidentialAddressYourDetailsIndividual: {
        SearchText: '',
        Address: '',
        LineOne: '',
        LineTwo: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      },
      ContactNumberYourDetailsIndividual: {
        ContactNumber: '',
      },
      EmailYourDetailsIndividual: '',
      YesNoEmailYourDetailsIndividual: false,
      ReceiveApplicationViaEmailYourDetailsIndividual: '',
      ReceiveCorrespondenceViaEmailYourDetailsIndividual: '',
      ContactNumberYourDetailsIndividualWarning: '',
      EmailYourDetailsIndividualWarning: '',
      // Step 10 Third Party
      GivenNamesYourDetailsThirdParty: '',
      FamilyNameYourDetailsThirdParty: '',
      RelationshipWithNamedPersonYourDetailsThirdParty: '',
      OrganisationNameYourDetailsThirdParty: '',
      PostalAddressYourDetailsThirdParty: {
        SearchText: '',
        Address: '',
        LineOne: '',
        LineTwo: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      },
      ContactNumberYourDetailsThirdParty: {
        ContactNumber: '',
      },
      EmailYourDetailsThirdParty: '',
      YesNoEmailYourDetailsThirdParty: false,
      ReceiveApplicationViaEmailYourDetailsThirdParty: '',
      CorrespondenceRecipientYourDetailsThirdParty: '',
      ContactNumberYourDetailsThirdPartyWarning: '',
      EmailYourDetailsThirdPartyWarning: '',
      // Step 10 Company
      GivenNamesYourDetailsCompany: '',
      FamilyNameYourDetailsCompany: '',
      PositionInCompanyYourDetailsCompany: '',
      CompanyNameYourDetailsCompany: '',
      AbnAcnTypeYourDetailsCompany: '',
      ABNYourDetailsCompany: '',
      ACNYourDetailsCompany: '',
      isABNValidYourDetails: false,
      isACNValidYourDetails: false,
      PostalAddressYourDetailsCompany: {
        SearchText: '',
        Address: '',
        LineOne: '',
        LineTwo: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      },
      DifferentToPostalYourDetailsCompany: '',
      StreetAddressYourDetailsCompany: {
        SearchText: '',
        Address: '',
        LineOne: '',
        LineTwo: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      },
      ContactNumberYourDetailsCompany: {
        ContactNumber: '',
      },
      EmailYourDetailsCompany: '',
      YesNoEmailYourDetailsCompany: false,
      ContactNumberYourDetailsCompanyWarning: '',
      EmailYourDetailsCompanyWarning: '',
      // Step 11 and 12
      AuthorisedObligation: {} as iObligation,
      EligibleObligations: [],
      // Step 11
      SelectedObligationsStep11: [],
      // Step 12
      areThereAnyAdditionalFines: '',
      obligationNumberToIncludeStep12: '',
      SelectedObligationsStep12: [],
      // Step 14
      ReviewConsentToDeclaration: false,
    }
  };
return defaultValues;
};

export const ReviewSchema = Yup.object().shape({
  // Step 4 - Partial Form
  saveEmail: Yup.string().matches(EMAIL_SPECIAL_CHARS_REGEX, INVALID_EMAIL).email(INVALID_EMAIL).required(INVALID_NUMERIC_FORMAT),
  saveMobile: Yup.string()
    .min(10, INVALID_MOBILE_NUMBER_FORMAT)
    .max(10, INVALID_PHONE_NUMBER_LENGTH)
    .matches(CONTACT_NUMBER_REGEX, INVALID_PHONE_NUMBER)
    .required(INVALID_PHONE_NUMBER),
  SaveYesNo: Yup.string().required(INVALID_YESNO_FORMAT),
  SaveOptions: Yup.string().when('SaveYesNo', {
    is: 'true',
    then: Yup.string().required(INVALID_NUMERIC_FORMAT),
  }),
  // Step 1
  OBLIGATION_NUMBER: Yup.string().matches(OBLIGATION_REGEX, INVALID_OBLIGATION_NUMBER).required(INVALID_NUMERIC_FORMAT),
  // Step 2
  OFFENCE_DATE: Yup.date().required(EMPTY_DATE).nullable().max(new Date(), INVALID_FUTURE_DATE),
  HEARING_DATE: Yup.date().required(EMPTY_DATE).nullable(),
  DRIVER_LICENCE: Yup.string()
    .required(INVALID_NUMERIC_FORMAT)
    .matches(/^[a-zA-Z0-9 ]*$/, INVALID_LICENCE_FORMAT_NOMINATION)
    .max(25, INVALID_INPUT_LONGER_THAN_25_CHARS),
  VEHICLE_REGISTRATION: Yup.string().matches(VEHICLE_REGISTRATION_REGEX, INVALID_VEHICLE_REGISTRATION_NUMBER).max(15, INVALID_INPUT_LONGER_THAN_15_CHARS).required(INVALID_VEHICLE_REGISTRATION_NUMBER),
  DOB: Yup.date().required(EMPTY_DATE).nullable().max(new Date(), INVALID_FUTURE_DATE),
  // Step 3
  WasSomeoneElseDrivingAtTimeOfOffence: Yup.string().required(INVALID_YESNO_FORMAT),
  ApplyingForPenaltyReminder: Yup.string().required(INVALID_YESNO_FORMAT),
  HaveYouSubmittedEnforcementReviewBefore: Yup.string().required(INVALID_YESNO_FORMAT),
  // Step 5
  isThePersonNamed: Yup.string().required(INVALID_YESNO_FORMAT),
  isThirdPartyAuthorised: Yup.boolean().oneOf([true], CONFIRM_AUTHORISED).required(),
  // Step 6 - General
  selectTheOption: Yup.array().min(1, INVALID_YESNO_FORMAT).required(),
  // Step 6 - Contrary to Law
  contraryToLawWasLegalMistakeMade: Yup.string().required(INVALID_YESNO_FORMAT),
  contraryToLawCanUploadSupportingDocs: Yup.string().required(INVALID_YESNO_FORMAT),
  // Step 6 - Exceptional Circumstances
  wereThereExceptionalCircumstances: Yup.string().required(INVALID_YESNO_FORMAT),
  exceptionalsCanUploadSupportingDocs: Yup.string().required(INVALID_YESNO_FORMAT),
  // Step 6 - Mistake of Identity
  wasThereAnIdentificationMistake: Yup.string().required(INVALID_YESNO_FORMAT),
  mistakeOfIdentityCanUploadSupportingDocs: Yup.string().required(INVALID_YESNO_FORMAT),
  mistakeOfIndentityWasSomeoneElseDriving: Yup.string().required(INVALID_YESNO_FORMAT),
  // Step 6 - Person Unaware
  personUnawareFindOutDate: Yup.date().required(EMPTY_DATE).nullable().max(new Date(), INVALID_FUTURE_DATE),
  personUnawareCanUploadSupportingDocs: Yup.string().required(INVALID_YESNO_FORMAT),
  personUnawareEnforcementHappened: Yup.string().required(INVALID_YESNO_FORMAT),
  personUnawareWasSomeoneElseDriving: Yup.string().required(INVALID_YESNO_FORMAT),
  // Step 6 - Special Circumstances
  wereThereSpecialCircumstances: Yup.string().required(INVALID_YESNO_FORMAT),
  specialsCanUploadSupportingDocs: Yup.string().required(INVALID_YESNO_FORMAT),
  // Step 8
  WhyYourFineShouldBeReviewed: Yup.string().matches(FREE_TEXT_FIELD_REGEX, INVALID_FREE_TEXT_FIELD_FORMAT).required(INVALID_NUMERIC_FORMAT),
  HasStatementAndEvidenceSupportingDocs: Yup.string().required(INVALID_YESNO_FORMAT),

  StatementAndEvidenceDescription: Yup.string().when('HasStatementAndEvidenceSupportingDocs', {
    is: 'true',
    then: Yup.string().matches(FREE_TEXT_FIELD_REGEX, INVALID_FREE_TEXT_FIELD_FORMAT),
  }),
  StatementAndEvidenceSizeErrorHandle: Yup.boolean().when('HasStatementAndEvidenceSupportingDocs', {
    is: 'true',
    then: Yup.boolean()
    .oneOf([false])
    .when('FileUploadSizeConfig', (FileUploadSizeConfig, schema) => (
      FileUploadSizeConfig
        ? schema.oneOf([false], `Sorry, this file is either too large (must be less than ${FileUploadSizeConfig}MB) or it’s a file type we don’t accept. Accepted file types include: doc, docx, xls, xlsx, csv, jpeg, png, pdf, txt.'`)
        : schema
    )),
  }),
  StatementAndEvidenceFileUploadErrorHandle: Yup.boolean().when('HasStatementAndEvidenceSupportingDocs', {
    is: 'true',
    then: Yup.boolean().oneOf([false], FILE_UPLOAD_FAIL),
  }),
  StatementAndEvidenceFileSectionError: Yup.boolean().when('StatementAndEvidence', {
    is: (StatementAndEvidence: []) => StatementAndEvidence.length < 1,
      then: Yup.boolean().when('HasStatementAndEvidenceSupportingDocs', {
        is: 'true',
        then: Yup.boolean().required(INVALID_NUMERIC_FORMAT)
      }),
  }),

  IsMakingTimeRequest: Yup.string().required(INVALID_YESNO_FORMAT),
  TimeExtension: Yup.string().required(INVALID_YESNO_FORMAT),
  // Step 8
  selectTheSpecialOption: Yup.array().min(1, INVALID_YESNO_FORMAT).required(),
  // Step 9
  GivenNamesFineholderDetails: Yup.string().matches(NAMES_FIELDS_REGEX, INVALID_NAME_FORMAT_NEW).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS).required(INVALID_NUMERIC_FORMAT),
  FamilyNameFineholderDetails: Yup.string().matches(NAMES_FIELDS_REGEX, INVALID_NAME_FORMAT_NEW).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS).required(INVALID_NUMERIC_FORMAT),
  DOBFineholderDetails: Yup.date().required(EMPTY_DATE).nullable().max(new Date(), INVALID_FUTURE_DATE),
  PlaceOfIssueFineholderDetails: Yup.string(),
  StateOfIssueFineholderDetails: Yup.string().required(INVALID_YESNO_FORMAT),
  YesNoDriverLicenceFineholderDetails: Yup.boolean(),
  PostalAddressFineholderDetails: Yup.object().shape({
    SearchText: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    LineOne: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS).required(INVALID_NUMERIC_FORMAT),
    LineTwo: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    Suburb: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    Postcode: Yup.string().matches(POST_CODE_REGEX, INVALID_POST_CODE).max(10, INVALID_INPUT_LONGER_THAN_10_CHARS).required(INVALID_NUMERIC_FORMAT),
    Country: Yup.string().max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    State: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION).required(INVALID_NUMERIC_FORMAT),
  }),
  DifferentToPostalFineholderDetails: Yup.string().required(INVALID_YESNO_FORMAT),
  ResidentialAddressFineholderDetails: Yup.object().shape({
    SearchText: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    LineOne: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS).required(INVALID_NUMERIC_FORMAT),
    LineTwo: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    Suburb: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    Postcode: Yup.string().matches(POST_CODE_REGEX, INVALID_POST_CODE).max(10, INVALID_INPUT_LONGER_THAN_10_CHARS).required(INVALID_NUMERIC_FORMAT),
    Country: Yup.string().max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    State: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION).required(INVALID_NUMERIC_FORMAT),
  }),
  ContactNumberFineholderDetails: Yup.object().shape({
    ContactNumber: Yup.string().max(15, INVALID_PHONE_NUMBER_LENGTH_15).matches(CONTACT_NUMBER_REGEX, INVALID_PHONE_NUMBER).required(INVALID_PHONE_NUMBER),
  }),
  EmailFineholderDetails: Yup.string()
    .matches(EMAIL_SPECIAL_CHARS_REGEX, INVALID_EMAIL)
    .email(INVALID_EMAIL)
    .max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION)
    .required(INVALID_NUMERIC_FORMAT),
  YesNoEmailFineholderDetails: Yup.boolean(),
  // Step 10 Individual
  GivenNamesYourDetailsIndividual: Yup.string().matches(NAMES_FIELDS_REGEX, INVALID_NAME_FORMAT_NEW).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS).required(INVALID_NUMERIC_FORMAT),
  FamilyNameYourDetailsIndividual: Yup.string().matches(NAMES_FIELDS_REGEX, INVALID_NAME_FORMAT_NEW).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS).required(INVALID_NUMERIC_FORMAT),
  DOBYourDetailsIndividual: Yup.date().required(EMPTY_DATE).nullable().max(new Date(), INVALID_FUTURE_DATE),
  PlaceOfIssueYourDetailsIndividual: Yup.string(),
  StateOfIssueYourDetailsIndividual: Yup.string().required(INVALID_YESNO_FORMAT),
  YesNoDriverLicenceYourDetailsIndividual: Yup.boolean(),
  PostalAddressYourDetailsIndividual: Yup.object().shape({
    SearchText: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    LineOne: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS).required(INVALID_NUMERIC_FORMAT),
    LineTwo: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    Suburb: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    Postcode: Yup.string().matches(POST_CODE_REGEX, INVALID_POST_CODE).max(10, INVALID_INPUT_LONGER_THAN_10_CHARS).required(INVALID_NUMERIC_FORMAT),
    Country: Yup.string().max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    State: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION).required(INVALID_NUMERIC_FORMAT),
  }),
  DifferentToPostalYourDetailsIndividual: Yup.string().required(INVALID_YESNO_FORMAT),
  ResidentialAddressYourDetailsIndividual: Yup.object().shape({
    SearchText: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    LineOne: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS).required(INVALID_NUMERIC_FORMAT),
    LineTwo: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    Suburb: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    Postcode: Yup.string().matches(POST_CODE_REGEX, INVALID_POST_CODE).max(10, INVALID_INPUT_LONGER_THAN_10_CHARS).required(INVALID_NUMERIC_FORMAT),
    Country: Yup.string().max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    State: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION).required(INVALID_NUMERIC_FORMAT),
  }),
  ContactNumberYourDetailsIndividual: Yup.object().shape({
    ContactNumber: Yup.string().max(15, INVALID_PHONE_NUMBER_LENGTH_15).matches(CONTACT_NUMBER_REGEX, INVALID_PHONE_NUMBER).required(INVALID_PHONE_NUMBER),
  }),
  EmailYourDetailsIndividual: Yup.string()
    .matches(EMAIL_SPECIAL_CHARS_REGEX, INVALID_EMAIL)
    .email(INVALID_EMAIL)
    .max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION)
    .required(INVALID_NUMERIC_FORMAT),
  YesNoEmailYourDetailsIndividual: Yup.boolean(),
  ReceiveApplicationViaEmailYourDetailsIndividual: Yup.string().required(INVALID_YESNO_FORMAT),
  ReceiveCorrespondenceViaEmailYourDetailsIndividual: Yup.string().required(INVALID_YESNO_FORMAT),
  // Step 10 Third Party
  GivenNamesYourDetailsThirdParty: Yup.string().matches(NAMES_FIELDS_REGEX, INVALID_NAME_FORMAT_NEW).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS).required(INVALID_NUMERIC_FORMAT),
  FamilyNameYourDetailsThirdParty: Yup.string().matches(NAMES_FIELDS_REGEX, INVALID_NAME_FORMAT_NEW).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS).required(INVALID_NUMERIC_FORMAT),
  RelationshipWithNamedPersonYourDetailsThirdParty: Yup.string().matches(FREE_TEXT_FIELD_REGEX, INVALID_FREE_TEXT_FIELD_FORMAT).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS).required(INVALID_NUMERIC_FORMAT),
  OrganisationNameYourDetailsThirdParty: Yup.string().matches(COMPANY_NAME_REGEX, INVALID_COMPANY_NAME),
  PostalAddressYourDetailsThirdParty: Yup.object().shape({
    SearchText: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    LineOne: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS).required(INVALID_NUMERIC_FORMAT),
    LineTwo: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    Suburb: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    Postcode: Yup.string().matches(POST_CODE_REGEX, INVALID_POST_CODE).max(10, INVALID_INPUT_LONGER_THAN_10_CHARS).required(INVALID_NUMERIC_FORMAT),
    Country: Yup.string().max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    State: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION).required(INVALID_NUMERIC_FORMAT),
  }),
  ContactNumberYourDetailsThirdParty: Yup.object().shape({
    ContactNumber: Yup.string().max(15, INVALID_PHONE_NUMBER_LENGTH_15).matches(CONTACT_NUMBER_REGEX, INVALID_PHONE_NUMBER).required(INVALID_PHONE_NUMBER),
  }),
  EmailYourDetailsThirdParty: Yup.string()
    .matches(EMAIL_SPECIAL_CHARS_REGEX, INVALID_EMAIL)
    .email(INVALID_EMAIL)
    .max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION)
    .required(INVALID_NUMERIC_FORMAT),
  YesNoEmailYourDetailsThirdParty: Yup.boolean(),
  ReceiveApplicationViaEmailYourDetailsThirdParty: Yup.string().required(INVALID_YESNO_FORMAT),
  CorrespondenceRecipientYourDetailsThirdParty: Yup.string().required(INVALID_YESNO_FORMAT),
  // Step 10 Company
  GivenNamesYourDetailsCompany: Yup.string().matches(NAMES_FIELDS_REGEX, INVALID_NAME_FORMAT_NEW).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS).required(INVALID_NUMERIC_FORMAT),
  FamilyNameYourDetailsCompany: Yup.string().matches(NAMES_FIELDS_REGEX, INVALID_NAME_FORMAT_NEW).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS).required(INVALID_NUMERIC_FORMAT),
  CompanyNameYourDetailsCompany: Yup.string().matches(COMPANY_NAME_REGEX, INVALID_COMPANY_NAME).max(75, INVALID_INPUT_LONGER_THAN_75_CHARS).required(INVALID_NUMERIC_FORMAT),
  PositionInCompanyYourDetailsCompany: Yup.string().matches(POSITION_IN_COMPANY_REGEX, INVALID_POSITION_IN_COMPANY_FIELD).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS).required(INVALID_NUMERIC_FORMAT),
  AbnAcnTypeYourDetailsCompany: Yup.string().required(INVALID_YESNO_FORMAT),
  ABNYourDetailsCompany: Yup.string().required(INVALID_NUMERIC_FORMAT)
  .min(ABN_MIN_LENGTH, INVALID_ABN)
  .test('is-valid', INVALID_ABN, function () {
    const { isABNValidYourDetails } = this.parent;
    return isABNValidYourDetails;
  }),
  ACNYourDetailsCompany: Yup.string().required(INVALID_NUMERIC_FORMAT)
  .min(ACN_MIN_LENGTH, INVALID_ACN)
  .test('is-valid', INVALID_ACN, function () {
    const { isACNValidYourDetails } = this.parent;
    return isACNValidYourDetails;
  }),
  PostalAddressYourDetailsCompany: Yup.object().shape({
    SearchText: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    LineOne: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS).required(INVALID_NUMERIC_FORMAT),
    LineTwo: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    Suburb: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    Postcode: Yup.string().matches(POST_CODE_REGEX, INVALID_POST_CODE).max(10, INVALID_INPUT_LONGER_THAN_10_CHARS).required(INVALID_NUMERIC_FORMAT),
    Country: Yup.string().max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    State: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION).required(INVALID_NUMERIC_FORMAT),
  }),
  DifferentToPostalYourDetailsCompany: Yup.string().required(INVALID_YESNO_FORMAT),
  StreetAddressYourDetailsCompany: Yup.object().shape({
    SearchText: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    LineOne: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS).required(INVALID_NUMERIC_FORMAT),
    LineTwo: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    Suburb: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    Postcode: Yup.string().matches(POST_CODE_REGEX, INVALID_POST_CODE).max(10, INVALID_INPUT_LONGER_THAN_10_CHARS).required(INVALID_NUMERIC_FORMAT),
    Country: Yup.string().max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    State: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION).required(INVALID_NUMERIC_FORMAT),
  }),
  ContactNumberYourDetailsCompany: Yup.object().shape({
    ContactNumber: Yup.string().max(15, INVALID_PHONE_NUMBER_LENGTH_15).matches(CONTACT_NUMBER_REGEX, INVALID_PHONE_NUMBER).required(INVALID_PHONE_NUMBER),
  }),
  EmailYourDetailsCompany: Yup.string().matches(EMAIL_SPECIAL_CHARS_REGEX, INVALID_EMAIL).email(INVALID_EMAIL).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION)
  .required(INVALID_NUMERIC_FORMAT),
  YesNoEmailYourDetailsCompany: Yup.boolean(),
  // Step 12
  areThereAnyAdditionalFines: Yup.string().required(INVALID_YESNO_FORMAT),
  obligationNumberToIncludeStep12: Yup.string().min(1, INVALID_OBLIGATION_NUMBER).matches(OBLIGATION_REGEX, INVALID_OBLIGATION_NUMBER).test('is-in-array',
  function (value) {
    const { SelectedObligationsStep12 } = this.parent;
    if (SelectedObligationsStep12.includes(value)) {
      return this.createError({
        message: 'The obligation number has been added already.'
      });
    }
    return true;
  })
  .test('does-array-have-atleaset-one-obligation',
  function (value) {
    const { SelectedObligationsStep12 } = this.parent;
    if ((SelectedObligationsStep12.length < 1 && !value)) {
      return this.createError({
        message: INVALID_NUMERIC_FORMAT
      });
    }
    return true;
  }),
  // Step 14
  ReviewConsentToDeclaration: Yup.boolean().oneOf([true], MISSING_DECLARATION_AGREEMENT),
});

export const ReviewMetaData: iFormMetaData = {
  pagesSegments: {
    step0: {
      progressStep: ProgressStep.START,
      validationKeys: (values:FormikValues) => keys(values, REVIEW).page0,
    },
    step1: {
      progressStep: ProgressStep.START,
      validationKeys: (values:FormikValues) => keys(values, REVIEW).page1,
    },
    step2: {
      progressStep: ProgressStep.START,
      validationKeys: (values:FormikValues) => keys(values, REVIEW).page2,
    },
    step3: {
      progressStep: ProgressStep.START,
      validationKeys: (values:FormikValues) => keys(values, REVIEW).page3,
    },
    step4: {
      progressStep: ProgressStep.START,
      validationKeys: (values:FormikValues) => keys(values, REVIEW).page4,
    },
    step5: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values:FormikValues) => keys(values, REVIEW).page5,
    },
    step6: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values:FormikValues) => keys(values, REVIEW).page6,
    },
    step7: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values:FormikValues) => keys(values, REVIEW).page7,
    },
    step8: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values:FormikValues) => keys(values, REVIEW).page8,
    },
    step9: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values:FormikValues) => keys(values, REVIEW).page9,
    },
    step10: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values:FormikValues) => keys(values, REVIEW).page10,
    },
    step11: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values:FormikValues) => keys(values, REVIEW).page11,
    },
    step12: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values:FormikValues) => keys(values, REVIEW).page12,
    },
    step13: {
      progressStep: ProgressStep.CHECK_CONFIRM,
      validationKeys: (values:FormikValues) => keys(values, REVIEW).page13,
    },
    step14: {
      progressStep: ProgressStep.CHECK_CONFIRM,
      validationKeys: (values:FormikValues) => keys(values, REVIEW).page14,
    },
    step15: {
      progressStep: ProgressStep.DONE,
      validationKeys: (values:FormikValues) => keys(values, REVIEW).page15,
    },
  },
};

const displayFileDetails = (attachment: iAttachments) => {
  if (attachment.FileName !== '' && attachment.FileDescription !== '') {
    return `${attachment.FileName} : ${attachment.FileDescription}`;
  }
  if (attachment.FileName !== '' && attachment.FileDescription === '') {
    return `${attachment.FileName}`;
  }
  return '';
};

const joinAddressFields = (entry: string[]) => {
  if (entry[0] === 'Address' || entry[0] === 'SearchText') return null;
  if (entry[0] === 'Country') return entry[1];
  return entry[1];
};

export const getSummaryScreen = (values: iReviewFormValues): iSummary[] => {
  const isSpecialCircumstance = values.selectTheOption.includes('SelectedGroundInfo4');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const isExceptionalCircumstance = values.selectTheOption.includes('SelectedGroundInfo1');
  const selectedGroundsMessage: Map<string, string> = new Map();
  selectedGroundsMessage.set('SelectedGroundInfo0', 'Contrary to law - The fine was invalid or not properly issued to you');
  selectedGroundsMessage.set('SelectedGroundInfo1', 'Exceptional circumstances - The offence occurred due to an extraordinary or unavoidable situation');
  selectedGroundsMessage.set('SelectedGroundInfo2', 'Mistake of identity - The fine was issued to the wrong person');
  selectedGroundsMessage.set('SelectedGroundInfo3', 'Person Unaware - You did not know about the fine');
  selectedGroundsMessage.set('SelectedGroundInfo4', 'Special circumstances - You have serious personal issues, disorders or difficulties');

  const selectedSpecialsGroundsMessage: Map<string, string> = new Map();
  selectedSpecialsGroundsMessage.set('SelectedSpecialsGroundInfo0', 'Mental or intellectual disability, disorder, disease or illness');
  selectedSpecialsGroundsMessage.set('SelectedSpecialsGroundInfo1', 'Alcohol, drug or volatile substance addiction');
  selectedSpecialsGroundsMessage.set('SelectedSpecialsGroundInfo2', 'Homelessness');
  selectedSpecialsGroundsMessage.set('SelectedSpecialsGroundInfo3', 'Disabling long-term circumstances making it impracticable to deal with the fine');
  selectedSpecialsGroundsMessage.set('SelectedSpecialsGroundInfo4', 'Family violence');
  const getSelectedSpecialCircumstances = values.selectTheSpecialOption.map((selectedSpecialCirc) => {
    if (selectedSpecialsGroundsMessage.has(selectedSpecialCirc)) return selectedSpecialsGroundsMessage.get(selectedSpecialCirc);
    return '';
  }).filter(Boolean)
  .join('\n ');

  const BeforeYouContinuePage = {
    title: 'Before you continue',
    editLink: '/step3',
    fields: [
      values.isInternalReviewStage && values.isDebtorTypeIndividual && values.isNominatable ? [{ title: 'Are you the person named on the infringement notice, but someone else was driving at the time of the offence?', value: values.WasSomeoneElseDrivingAtTimeOfOffence === 'true' ? 'Yes' : 'No' }] : [],
      values.isInternalReviewStage && values.isDebtorTypeIndividual && values.Status === 'PenaltyReminder' ? [{ title: 'Are you applying to have the Penalty Reminder fee waived?', value: values.ApplyingForPenaltyReminder === 'true' ? 'Yes' : 'No' }] : [],
      values.isEnforcementReviewStage ? [{ title: 'Have you submitted an enforcement review application for this fine before?', value: values.HaveYouSubmittedEnforcementReviewBefore === 'true' ? 'Yes' : 'No' }] : [],
    ],
  };

  const whichStatementPage = {
    title: 'Which statement best describes you?',
    editLink: '/step5',
    fields: [
      [{ title: 'Which statement best describes you?', value: values.isThePersonNamed === 'true' ? 'I am the person named on the fine' : 'I am authorised to act on behalf of the person named on  the fine' }],
    ],
  };

  const whyAreYouRequestingAReviewPage = {
    title: 'Why are you requesting a review?',
    editLink: '/step6',
    fields: [
      [{ title: 'Please review the different grounds below carefully and select the one that best applies to your circumstances.', value: selectedGroundsMessage.has(values.selectTheOption[0]) ? selectedGroundsMessage.get(values.selectTheOption[0])! : 'n/a' }],
      values.selectTheOption.includes('SelectedGroundInfo0') ? [{ title: 'Do you believe a legal mistake was made when this fine was issued?', value: values.contraryToLawWasLegalMistakeMade === 'true' ? 'Yes' : 'No' }] : [],
      values.selectTheOption.includes('SelectedGroundInfo0') ? [{ title: 'Can you upload documents to support this?', value: values.contraryToLawCanUploadSupportingDocs === 'true' ? 'Yes' : 'No' }] : [],
      values.selectTheOption.includes('SelectedGroundInfo1') ? [{ title: 'Was the fine due to circumstances that were out of the ordinary, unavoidable or exceptional?', value: values.wereThereExceptionalCircumstances === 'true' ? 'Yes' : 'No' }] : [],
      values.selectTheOption.includes('SelectedGroundInfo1') ? [{ title: 'Can you upload documents to support this?', value: values.exceptionalsCanUploadSupportingDocs === 'true' ? 'Yes' : 'No' }] : [],
      values.selectTheOption.includes('SelectedGroundInfo2') ? [{ title: 'Do you believe an identification mistake was made when the fine was issued?', value: values.wasThereAnIdentificationMistake === 'true' ? 'Yes' : 'No' }] : [],
      values.selectTheOption.includes('SelectedGroundInfo2') ? [{ title: 'Can you upload documents to support this?', value: values.mistakeOfIdentityCanUploadSupportingDocs === 'true' ? 'Yes' : 'No' }] : [],
      values.selectTheOption.includes('SelectedGroundInfo2') ? [{ title: 'Are you the vehicle owner but someone else was driving at the time of the offence?', value: values.mistakeOfIndentityWasSomeoneElseDriving === 'true' ? 'Yes' : 'No' }] : [],
      values.selectTheOption.includes('SelectedGroundInfo3') ? [{ title: 'When did you first find out about the fine?', value: values.personUnawareFindOutDate ? `${(`0${values.personUnawareFindOutDate.getDate()}`).slice(-2)}/${(`0${values.personUnawareFindOutDate.getMonth() + 1}`).slice(-2)}/${values.personUnawareFindOutDate.getFullYear()}` : 'n/a' }] : [],
      values.selectTheOption.includes('SelectedGroundInfo3') ? [{ title: 'Can you upload documents to support this?', value: values.personUnawareCanUploadSupportingDocs === 'true' ? 'Yes' : 'No' }] : [],
      values.selectTheOption.includes('SelectedGroundInfo3') && values.isEnforcementReviewStage ? [{ title: 'Has any enforcement action already happened for the fine(s)?', value: values.personUnawareEnforcementHappened === 'true' ? 'Yes' : 'No' }] : [],
      values.selectTheOption.includes('SelectedGroundInfo3') && values.isEnforcementReviewStage ? [{ title: 'Was someone else driving?', value: values.personUnawareWasSomeoneElseDriving === 'true' ? 'Yes' : 'No' }] : [],
      values.selectTheOption.includes('SelectedGroundInfo4') ? [{ title: 'Do one or more of these special circumstances apply to you?', value: values.wereThereSpecialCircumstances === 'true' ? 'Yes' : 'No' }] : [],
      values.selectTheOption.includes('SelectedGroundInfo4') ? [{ title: 'Can you upload documents to support this?', value: values.specialsCanUploadSupportingDocs === 'true' ? 'Yes' : 'No' }] : [],
    ],
  };

  const applyingWithSpecialCircumstancesPage = {
    title: 'Applying with special circumstances',
    editLink: '/step7',
    fields: [
      [{ title: 'Which statement(s) best describes your situation?', value: values.selectTheSpecialOption.length > 0 ? getSelectedSpecialCircumstances : 'n/a' }],
    ],
  };

  const yourStatementPage = {
    title: 'Your statement and evidence',
    editLink: '/step8',
    fields: [
      [{ title: 'Tell us why you believe your fine(s) should be reviewed. Make sure you provide plenty of information to support your claim.', value: values.WhyYourFineShouldBeReviewed ? values.WhyYourFineShouldBeReviewed : 'n/a' }],
      values.HasStatementAndEvidenceSupportingDocs ? [
          {
            title: 'Supporting documents',
            value: values.StatementAndEvidence && values.StatementAndEvidence.length > 0 ? values.StatementAndEvidence.map((attachment) => displayFileDetails(attachment))
              .filter(Boolean)
              .join('\n')
              : 'Not provided',
          },
        ] : [],
      values.isEnforcementReviewStage && (isExceptionalCircumstance || isSpecialCircumstance) ? [
        {
          title: 'Would you like to ask for more time to get evidence to support this application?',
          value: values.IsMakingTimeRequest === 'true' ? 'Yes' : 'No',
        },
      ] : [],
      values.isEnforcementReviewStage && (isExceptionalCircumstance || isSpecialCircumstance) && values.IsMakingTimeRequest === 'true' ? [
        {
          title: 'How much time do you need to get evidence?',
          value: values.TimeExtension,
        },
      ] : [],
    ],
  };

  const fineHolderDetailsPage = {
    title: 'Fineholder details',
    editLink: '/step9',
    fields: [
      [{ title: 'Given name(s)', value: values.GivenNamesFineholderDetails ? values.GivenNamesFineholderDetails : 'n/a' }],
      [{ title: 'Family name', value: values.FamilyNameFineholderDetails ? values.FamilyNameFineholderDetails : 'n/a' }],
      [{ title: 'Date of birth', value: values.DOBFineholderDetails ? `${(`0${values.DOBFineholderDetails.getDate()}`).slice(-2)}/${(`0${values.DOBFineholderDetails.getMonth() + 1}`).slice(-2)}/${values.DOBFineholderDetails.getFullYear()}` : 'n/a' }],
      [
        !values.YesNoDriverLicenceFineholderDetails
          ? { title: 'Driver licence number', value: values.DRIVER_LICENCE }
          : { title: 'Driver licence number', value: 'n/a' },
      ],
      [
        !values.YesNoDriverLicenceFineholderDetails
          ? { title: 'Place of issue', value: values.PlaceOfIssueFineholderDetails === 'Australia' ? values.StateOfIssueFineholderDetails : values.PlaceOfIssueFineholderDetails }
          : { title: 'Place of issue', value: 'n/a' },
      ],
      [
        {
          title: 'Postal address',
          value: `${Object.entries(values.PostalAddressFineholderDetails)
            .map((entry) => joinAddressFields(entry))
            .filter(Boolean)
            .join(', ')}`,
        },
      ],
      values.DifferentToPostalFineholderDetails === 'true' ? [
        {
          title: 'Residential address',
          value: `${Object.entries(values.ResidentialAddressFineholderDetails)
            .map((entry) => joinAddressFields(entry))
            .filter(Boolean)
            .join(', ')}`,
        },
      ] : [
        {
          title: "Is the fineholder's residential address different to their postal address?",
          value: values.DifferentToPostalFineholderDetails === 'true' ? 'Yes' : 'No',
        }
      ],
      [{ title: 'Contact phone number', value: values.ContactNumberFineholderDetails.ContactNumber ? values.ContactNumberFineholderDetails.ContactNumber : 'n/a' }],
      values.YesNoEmailFineholderDetails === false ? [{ title: 'Email address', value: values.EmailFineholderDetails ? values.EmailFineholderDetails : 'n/a' }] : [{ title: 'Email address', value: 'n/a' }],
    ],
  };

  const IndividualDetails = [
    [{ title: 'Given name(s)', value: values.GivenNamesYourDetailsIndividual ? values.GivenNamesYourDetailsIndividual : 'n/a' }],
    [{ title: 'Family name', value: values.FamilyNameYourDetailsIndividual ? values.FamilyNameYourDetailsIndividual : 'n/a' }],
    [{ title: 'Date of birth', value: values.DOBYourDetailsIndividual ? `${(`0${values.DOBYourDetailsIndividual.getDate()}`).slice(-2)}/${(`0${values.DOBYourDetailsIndividual.getMonth() + 1}`).slice(-2)}/${values.DOBYourDetailsIndividual.getFullYear()}` : 'n/a' }],
    [
      !values.YesNoDriverLicenceYourDetailsIndividual
        ? { title: 'Driver licence number', value: values.DRIVER_LICENCE }
        : { title: 'Driver licence number', value: 'n/a' },
    ],
    [
      !values.YesNoDriverLicenceYourDetailsIndividual
        ? { title: 'Place of issue', value: values.PlaceOfIssueYourDetailsIndividual === 'Australia' ? values.StateOfIssueYourDetailsIndividual : values.PlaceOfIssueYourDetailsIndividual }
        : { title: 'Place of issue', value: 'n/a' },
    ],
    [
      {
        title: 'Postal address',
        value: `${Object.entries(values.PostalAddressYourDetailsIndividual)
          .map((entry) => joinAddressFields(entry))
          .filter(Boolean)
          .join(', ')}`,
      },
    ],
    values.DifferentToPostalYourDetailsIndividual === 'true' ? [
      {
        title: 'Residential address',
        value: `${Object.entries(values.ResidentialAddressYourDetailsIndividual)
          .map((entry) => joinAddressFields(entry))
          .filter(Boolean)
          .join(', ')}`,
      },
    ] : [
      {
        title: 'Is your residential address different to your postal address?',
        value: values.DifferentToPostalYourDetailsIndividual === 'true' ? 'Yes' : 'No',
      }
    ],
    [{ title: 'Contact phone number', value: values.ContactNumberYourDetailsIndividual.ContactNumber ? values.ContactNumberYourDetailsIndividual.ContactNumber : 'n/a' }],
    values.YesNoEmailYourDetailsIndividual === false ? [{ title: 'Email address', value: values.EmailYourDetailsIndividual ? values.EmailYourDetailsIndividual : 'n/a' }] : [{ title: 'Email address', value: 'n/a' }],
    isSpecialCircumstance && values.YesNoEmailYourDetailsIndividual === false ? [{ title: 'Would you like to receive a copy of the completed application at the email address provided?', value: values.ReceiveApplicationViaEmailYourDetailsIndividual ? values.ReceiveApplicationViaEmailYourDetailsIndividual === 'true' ? 'Yes' : 'No' : 'n/a' }] : [],
    values.isEnforcementReviewStage && values.YesNoEmailYourDetailsIndividual === false ? [{ title: 'Do you consent to receiving correspondence about this application via email?', value: values.ReceiveCorrespondenceViaEmailYourDetailsIndividual ? values.ReceiveCorrespondenceViaEmailYourDetailsIndividual === 'true' ? 'Yes' : 'No' : 'n/a' }] : [],
  ];
  const CompanyDetails = [
    [{ title: 'Given name(s)', value: values.GivenNamesYourDetailsCompany ? values.GivenNamesYourDetailsCompany : 'n/a' }],
    [{ title: 'Family name', value: values.FamilyNameYourDetailsCompany ? values.FamilyNameYourDetailsCompany : 'n/a' }],
    [{ title: 'Position in company', value: values.PositionInCompanyYourDetailsCompany ? values.PositionInCompanyYourDetailsCompany : 'n/a' }],
    [{ title: 'Company name', value: values.CompanyNameYourDetailsCompany ? values.CompanyNameYourDetailsCompany : 'n/a' }],
    [{ title: 'ACN or ABN (an ACN is preferred)', value: values.AbnAcnTypeYourDetailsCompany }],
    [{ title: 'Enter the ACN/ABN number', value: values.AbnAcnTypeYourDetailsCompany === 'ACN' ? values.ACNYourDetailsCompany : values.ABNYourDetailsCompany }],
    [
      {
        title: 'Postal address',
        value: `${Object.entries(values.PostalAddressYourDetailsCompany)
          .map((entry) => joinAddressFields(entry))
          .filter(Boolean)
          .join(', ')}`,
      },
    ],
    values.DifferentToPostalYourDetailsCompany === 'true' ? [
      {
        title: 'Street address',
        value: `${Object.entries(values.StreetAddressYourDetailsCompany)
          .map((entry) => joinAddressFields(entry))
          .filter(Boolean)
          .join(', ')}`,
      },
    ] : [
      {
        title: 'Is the street address different to the postal address?',
        value: values.DifferentToPostalYourDetailsCompany === 'true' ? 'Yes' : 'No',
      }
    ],
    [{ title: 'Contact phone number', value: values.ContactNumberYourDetailsCompany.ContactNumber ? values.ContactNumberYourDetailsCompany.ContactNumber : 'n/a' }],
    values.YesNoEmailYourDetailsCompany === false ? [{ title: 'Email address', value: values.EmailYourDetailsCompany ? values.EmailYourDetailsCompany : 'n/a' }] : [{ title: 'Email address', value: 'n/a' }],
  ];
  const ThirdPartyDetails = [
    [{ title: 'Given name(s)', value: values.GivenNamesYourDetailsThirdParty ? values.GivenNamesYourDetailsThirdParty : 'n/a' }],
    [{ title: 'Family name', value: values.FamilyNameYourDetailsThirdParty ? values.FamilyNameYourDetailsThirdParty : 'n/a' }],
    [{ title: 'Your relationship to the person who received the fine (for example, family member, legal representative, support worker)', value: values.RelationshipWithNamedPersonYourDetailsThirdParty ? values.RelationshipWithNamedPersonYourDetailsThirdParty : 'n/a' }],
    [{ title: 'Organisation name (if applicable)', value: values.OrganisationNameYourDetailsThirdParty ? values.OrganisationNameYourDetailsThirdParty : 'n/a' }],
    [
      {
        title: 'Postal address',
        value: `${Object.entries(values.PostalAddressYourDetailsThirdParty)
          .map((entry) => joinAddressFields(entry))
          .filter(Boolean)
          .join(', ')}`,
      },
    ],
    [{ title: 'Contact phone number', value: values.ContactNumberYourDetailsThirdParty.ContactNumber ? values.ContactNumberYourDetailsThirdParty.ContactNumber : 'n/a' }],
    values.YesNoEmailYourDetailsThirdParty === false ? [{ title: 'Email address', value: values.EmailYourDetailsThirdParty ? values.EmailYourDetailsThirdParty : 'n/a' }] : [{ title: 'Email address', value: 'n/a' }],
    isSpecialCircumstance && values.YesNoEmailYourDetailsThirdParty === false ? [{ title: 'Would you like to receive a copy of the completed application at the email address provided?', value: values.ReceiveApplicationViaEmailYourDetailsThirdParty === 'true' ? 'Yes' : 'No' }] : [],
    (isSpecialCircumstance && (values.ReceiveApplicationViaEmailYourDetailsThirdParty === 'true')) || !isSpecialCircumstance ? [{ title: 'Where would you like us to send correspondence about this application?', value: values.CorrespondenceRecipientYourDetailsThirdParty }] : [],
  ];
  let yourDetailsContent = null;
  let yourDetailsTitle = null;
  if (values.isDebtorTypeIndividual) {
    yourDetailsContent = IndividualDetails;
    yourDetailsTitle = reviewInfoDisplayObject.pages.IndividualContactInformation.pageTitle;
  }
  if (values.isDebtorTypeCompany) {
    yourDetailsContent = CompanyDetails;
    yourDetailsTitle = reviewInfoDisplayObject.pages.CompanyContactInformation.pageTitle;
  }
  if (values.isThirdPartyAuthorised) {
    yourDetailsContent = ThirdPartyDetails;
    yourDetailsTitle = reviewInfoDisplayObject.pages.ThirdPartyRepContactInformation.pageTitle;
  }
  const yourDetailsPage = {
    title: yourDetailsTitle !== null ? yourDetailsTitle : 'Your details',
    editLink: '/step10',
    fields: yourDetailsContent !== null ? yourDetailsContent : [] as iSummaryField[][],
  };
  const checkFinesStep11 = values.SelectedObligationsStep11.map((fine) => {
    if (fine.checked) return fine.number.toString();
    return '';
  }).filter(Boolean)
  .join('; ');
  const checkFinesStep12Entered = values.SelectedObligationsStep12.map((fine) => {
    if (fine) return fine;
    return '';
  }).filter(Boolean)
  .join('\n ');
  const yourFinesPageIndividual = {
    title: 'Your fines',
    editLink: '/step11',
    fields: [
      [{
        title: 'Fines to be included in this application',
        value: checkFinesStep11 ? `${checkFinesStep11}; ${values.AuthorisedObligation.Number}` : values.AuthorisedObligation.Number,
      }],
    ],
  };
  const yourFinesPageCompanyOrThirdParty = {
    title: 'Your fines',
    editLink: '/step12',
    fields: [
      [{
        title: 'Would you like to add any other fines to this application?',
        value: values.areThereAnyAdditionalFines !== ''
        ? values.areThereAnyAdditionalFines === 'listFinesManually'
          ? 'Include these fines in this application'
          : values.areThereAnyAdditionalFines === 'includeAllFines'
            ? 'All eligible outstanding fines'
            : values.areThereAnyAdditionalFines === 'noOtherFines'
              ? 'No other fines'
              : 'n/a'
        : 'n/a',
      }],
      values.areThereAnyAdditionalFines === 'listFinesManually'
      ? [{
        title: 'Entered obligation number or infringement number',
        value: values.SelectedObligationsStep12.length > 0 ? `${values.AuthorisedObligation.Number}\n ${checkFinesStep12Entered}` : values.AuthorisedObligation.Number
       }] : []
    ],
  };
  const pagesExtensionSummary: iSummary[] = [
    (values.isDebtorTypeIndividual && values.isInternalReviewStage) || values.isEnforcementReviewStage ? BeforeYouContinuePage : ({} as iSummary),
    values.isDebtorTypeIndividual ? whichStatementPage : ({} as iSummary),
    whyAreYouRequestingAReviewPage,
    isSpecialCircumstance ? applyingWithSpecialCircumstancesPage : ({} as iSummary),
    yourStatementPage,
    values.isThirdPartyAuthorised ? fineHolderDetailsPage : ({} as iSummary),
    yourDetailsPage,
    values.isDebtorTypeIndividual && !values.isThirdPartyAuthorised ? yourFinesPageIndividual : ({} as iSummary),
    values.isThirdPartyAuthorised || values.isDebtorTypeCompany ? yourFinesPageCompanyOrThirdParty : ({} as iSummary)
  ];
  const summarySections: iSummary[] = pagesExtensionSummary;
  return summarySections;
};

export interface iSubmitReviewFormValues extends iCommonReviewValues {
  // OBLIGATION FIELDS
  YourObligationNumber: string;
  InfringementNoticeNumber: string;
  OffenceDate: string;
  // Footer Pg 1
  FooterSubmissionNo1: string;
  FooterFormType1: string;
  FooterObligationNo1: string;
  FooterSubmissionTime1: string;
  // Footer Pg 2
  FooterSubmissionNo2: string;
  FooterFormType2: string;
  FooterObligationNo2: string;
  FooterSubmissionTime2: string;
  // Footer Pg 3
  FooterSubmissionNo3: string;
  FooterFormType3: string;
  FooterObligationNo3: string;
  FooterSubmissionTime3: string;
  // Footer Pg 4
  FooterSubmissionNo4: string;
  FooterFormType4: string;
  FooterObligationNo4: string;
  FooterSubmissionTime4: string;

  // ##IR PDF Fields##
  // Before You Continue
  WhichStatementBestDescribesYou: string; // IR Only
  PRNFeeWaive: string; // IR Only
  // Details of the Person or Company Named on the Infringement
    // Individual Details
  GivenNames: string;
  FamilyNameSurname: string;
  DateOfBirth: string;
  DriverLicenceNumber: string;
  NoLicenceNumber: string;
  CountryOfIssue: string;
  StateOfIssue: string;

      // Contact Details
  ContactNumber: string;
  EmailAddressOptional: string;
  ContactByEmail: string;

    //  Company Details
  CompanyName: string;
  AbnacnType: string;
  AbnacnNo: string;

  // Details of authorised/company representative completing this application
  RepresentativeGivenNames: string;
  RepresentativeFamilyNameSurname: string;
  PositionInCompany: string;

    // Contact details
  AuthRepContactNumber: string;
  AuthRepSendCorroTo: string;
  AuthRepOrgName: string;
  AuthRepEmail: string;
  AuthRepContactByEmail: string;
  PositionrelationshipToApplicant: string;

  // Reason for requesting an internal review
  ReviewGround: string;

  // Special Circumstances ground(s) (if applicable)
  SpecialCircumstancesGround: string;
  WhenDidYouFindOutAboutTheFine: string;

  // Why do you believe the fine(s) should be reviewed?
  WhyShouldFineBeReviewed: string;

  // Supporting Material
  DocumentDescription: string;
  NumberOfAttachments: string;
  EMAIL_TO: string;
  OBLIGATION_NUMBER: string;

  // Fines to include in this application
  FinesToInclude: string;

  // Declaration
  SignatureOfApplicant: string;
  DeclarationDate: string;

  // ##ER Individual PDF fields##
  TimeNeededToGetEvidence: string;

  // All Address fields across pdfs
  //   ADDRESS 1 - IR and ER -> (IR) Company Street - (ER Third Party) Residential - (ER Individual) Residential - (ER Company) Company Street
  LineOne: string;
  LineTwo: string;
  Suburb: string;
  State: string;
  Postcode: string;
  Country: string;
    // ADDRESS 2 - IR and ER -> (IR) Company Postal - (ER Third Party) Postal - (ER Individual) Postal - (ER Company) Company Postal
  LineOneTwo: string;
  LineTwoTwo: string;
  SuburbTwo: string;
  StateTwo: string;
  PostcodeTwo: string;
  CountryTwo: string;
    // ADDRESS 3 - IR
  LineOneThree: string;
  LineTwoThree: string;
  SuburbThree: string;
  StateThree: string;
  PostcodeThree: string;
  CountryThree: string;
    // ADDRESS 4 - IR
  LineOneFour: string;
  LineTwoFour: string;
  SuburbFour: string;
  StateFour: string;
  PostcodeFour: string;
  CountryFour: string;
    // ADDRESS 5 - IR
  LineOneFive: string;
  LineTwoFive: string;
  SuburbFive: string;
  StateFive: string;
  PostcodeFive: string;
  CountryFive: string;
}
export const getSubmissionPayload = (formValues: iReviewFormValues, submissionNumber: string): iSubmitReviewFormValues => {
  const submitFormValues = formValues;
  const now = new Date();
  const MONTH = (`0${now.getMonth() + 1}`).slice(-2);
  const DATE = (`0${now.getDate()}`).slice(-2);
  const YEAR = now.getFullYear();
  const MINUTE = (now.getMinutes() < 10 ? '0' : '') + now.getMinutes();
  const SUBMITTED_TIME = `${now.getHours()}:${MINUTE} ${DATE}/${MONTH}/${YEAR}`;
  const FORM_TYPE = 'Review';
  const isSpecialCircumstance = formValues.selectTheOption.includes('SelectedGroundInfo4');

  let statementDescribesYou = '';
  if (formValues.isThePersonNamed === 'true') {
    statementDescribesYou = 'I am the person named on the fine';
  }
  if (formValues.isThirdPartyAuthorised) {
    statementDescribesYou = 'I am authorised to act on behalf of the person named on the fine';
  }
  const selectedSpecialsGroundsMessageOptions: Map<string, string> = new Map();
  selectedSpecialsGroundsMessageOptions.set('SelectedSpecialsGroundInfo0', 'Mental or intellectual disability, disorder, disease or illness');
  selectedSpecialsGroundsMessageOptions.set('SelectedSpecialsGroundInfo1', 'Alcohol, drug or volatile substance addiction');
  selectedSpecialsGroundsMessageOptions.set('SelectedSpecialsGroundInfo2', 'Homelessness');
  selectedSpecialsGroundsMessageOptions.set('SelectedSpecialsGroundInfo3', 'Disabling long-term circumstances making it impracticable to deal with the fine');
  selectedSpecialsGroundsMessageOptions.set('SelectedSpecialsGroundInfo4', 'Family violence');

  const selectedGroundsMessageOptions: Map<string, string> = new Map();
  selectedGroundsMessageOptions.set('SelectedGroundInfo0', 'Contrary to law - The fine was invalid or not properly issued to you');
  selectedGroundsMessageOptions.set('SelectedGroundInfo1', 'Exceptional circumstances - The offence occurred due to an extraordinary or unavoidable situation');
  selectedGroundsMessageOptions.set('SelectedGroundInfo2', 'Mistake of identity - The fine was issued to the wrong person');
  selectedGroundsMessageOptions.set('SelectedGroundInfo3', 'Person Unaware - You did not know about the fine');
  selectedGroundsMessageOptions.set('SelectedGroundInfo4', 'Special circumstances - You have serious personal issues, disorders or difficulties');

  const getSelectedSpecialCircumstances = formValues.selectTheSpecialOption.map((selectedSpecialCirc) => {
    if (selectedSpecialsGroundsMessageOptions.has(selectedSpecialCirc)) return selectedSpecialsGroundsMessageOptions.get(selectedSpecialCirc);
    return '';
  }).filter(Boolean)
  .join('; ');
  const checkFinesStep11 = formValues.SelectedObligationsStep11.map((fine) => {
    if (fine.checked) return fine.number.toString();
    return '';
  }).filter(Boolean)
  .join('; ');
  const checkFinesStep12AllEligible = formValues.EligibleObligations.map((fine) => {
    if (fine) return fine.Number.toString();
    return '';
  }).filter(Boolean)
  .join('; ');
  const checkFinesStep12ManuallyEntered = formValues.SelectedObligationsStep12.map((fine) => {
    if (fine) return fine;
    return '';
  }).filter(Boolean)
  .join('; ');
  const getSelectedObsStep11 = (checkFinesStep11
    ? `${checkFinesStep11}; ${formValues.AuthorisedObligation.Number}`
    : formValues.AuthorisedObligation.Number
  );
  const getSelectedObsStep12 = (formValues.areThereAnyAdditionalFines === 'includeAllFines'
  ? (checkFinesStep12AllEligible
    ? `${checkFinesStep12AllEligible}; ${formValues.AuthorisedObligation.Number}`
    : formValues.AuthorisedObligation.Number
    )
  : (formValues.SelectedObligationsStep12.length > 0
    ? `${checkFinesStep12ManuallyEntered}; ${formValues.AuthorisedObligation.Number}`
    : formValues.AuthorisedObligation.Number
    )
  );

  const totalNumberOfAttachments = formValues.StatementAndEvidence?.length;
  let remoteAttachmentNames = '';
  let uploadedFileDescriptions = '';
  const descriptionOfAttachmentsArray = [
    ...(formValues.StatementAndEvidence || [])
  ];
  if (descriptionOfAttachmentsArray) {
    descriptionOfAttachmentsArray.forEach((v) => {
      if (v.RemoteFileName) {
        remoteAttachmentNames += `${formValues.OBLIGATION_NUMBER}/${v.RemoteFileName}/${v.RemoteFileName}|`;
      }
      if (v.FileDescription) {
        uploadedFileDescriptions += `${v.FileDescription}; `;
      }
    });
  }

  const submitObject: iSubmitReviewFormValues = {
    ...(submitFormValues as iCommonReviewValues),
    // OBLIGATION FIELDS
    YourObligationNumber: formValues.OBLIGATION_NUMBER,
    InfringementNoticeNumber: formValues.InfringementNumber,
    OffenceDate: `${`${`0${formValues.OFFENCE_DATE?.getDate()}`.slice(-2)}/${`0${formValues.OFFENCE_DATE!.getMonth() + 1}`.slice(-2)}`}/${formValues.OFFENCE_DATE?.getFullYear()}`,

    // ##IR Fields##
    // Before You Continue
    WhichStatementBestDescribesYou: statementDescribesYou,
    PRNFeeWaive: formValues.ApplyingForPenaltyReminder !== '' ? (formValues.ApplyingForPenaltyReminder === 'true' ? 'Yes' : 'No') : '',
    // Details of the Person or Company Named on the Infringement
      // Individual Details
    GivenNames: formValues.isThirdPartyAuthorised ? formValues.GivenNamesFineholderDetails : (formValues.isDebtorTypeIndividual ? formValues.GivenNamesYourDetailsIndividual : ''),
    FamilyNameSurname: formValues.isThirdPartyAuthorised ? formValues.FamilyNameFineholderDetails : (formValues.isDebtorTypeIndividual ? formValues.FamilyNameYourDetailsIndividual : ''),
    DateOfBirth: formValues.isThirdPartyAuthorised ? (formValues.DOBFineholderDetails ? `${(`0${formValues.DOBFineholderDetails.getDate()}`).slice(-2)}/${(`0${formValues.DOBFineholderDetails.getMonth() + 1}`).slice(-2)}/${formValues.DOBFineholderDetails.getFullYear()}` : '') : (formValues.isDebtorTypeIndividual ? (formValues.DOBYourDetailsIndividual ? `${(`0${formValues.DOBYourDetailsIndividual.getDate()}`).slice(-2)}/${(`0${formValues.DOBYourDetailsIndividual.getMonth() + 1}`).slice(-2)}/${formValues.DOBYourDetailsIndividual.getFullYear()}` : '') : ''),
    DriverLicenceNumber: ((formValues.isThirdPartyAuthorised && !formValues.YesNoDriverLicenceFineholderDetails) || (formValues.isDebtorTypeIndividual && !formValues.YesNoDriverLicenceYourDetailsIndividual)) ? formValues.DRIVER_LICENCE : '',
    NoLicenceNumber: formValues.isThirdPartyAuthorised ? (formValues.YesNoDriverLicenceFineholderDetails ? 'Yes' : '') : (formValues.isDebtorTypeIndividual ? (formValues.YesNoDriverLicenceYourDetailsIndividual ? 'Yes' : '') : ''),
    CountryOfIssue: (formValues.isThirdPartyAuthorised && !formValues.YesNoDriverLicenceFineholderDetails) ? formValues.PlaceOfIssueFineholderDetails : (formValues.isDebtorTypeIndividual && !formValues.YesNoDriverLicenceYourDetailsIndividual ? formValues.PlaceOfIssueYourDetailsIndividual : ''),
    StateOfIssue: (formValues.isThirdPartyAuthorised && !formValues.YesNoDriverLicenceFineholderDetails) ? (formValues.PlaceOfIssueFineholderDetails === 'Australia' ? formValues.StateOfIssueFineholderDetails : 'International') : (formValues.isDebtorTypeIndividual && !formValues.YesNoDriverLicenceYourDetailsIndividual ? (formValues.PlaceOfIssueYourDetailsIndividual === 'Australia' ? formValues.StateOfIssueYourDetailsIndividual : 'International') : ''),

        // Contact Details
    ContactNumber: formValues.isThirdPartyAuthorised ? formValues.ContactNumberFineholderDetails.ContactNumber : (formValues.isDebtorTypeIndividual ? formValues.ContactNumberYourDetailsIndividual.ContactNumber : formValues.isDebtorTypeCompany ? (formValues.isEnforcementReviewStage ? formValues.ContactNumberYourDetailsCompany.ContactNumber : '') : ''),
    EmailAddressOptional: formValues.isThirdPartyAuthorised ? formValues.EmailFineholderDetails : (formValues.isDebtorTypeIndividual ? formValues.EmailYourDetailsIndividual : (formValues.isEnforcementReviewStage ? formValues.isDebtorTypeCompany : '') ? formValues.EmailYourDetailsCompany : ''),
    ContactByEmail: formValues.isDebtorTypeIndividual && formValues.isEnforcementReviewStage && !formValues.YesNoEmailYourDetailsIndividual && !formValues.isThirdPartyAuthorised ? (formValues.ReceiveCorrespondenceViaEmailYourDetailsIndividual === 'true' ? 'Yes' : 'No') : '',

      //  Company Details
    CompanyName: formValues.isDebtorTypeCompany ? formValues.CompanyNameYourDetailsCompany : '',
    AbnacnType: formValues.isDebtorTypeCompany ? formValues.AbnAcnTypeYourDetailsCompany : '',
    AbnacnNo: formValues.isDebtorTypeCompany ? (formValues.AbnAcnTypeYourDetailsCompany === 'ACN' ? formValues.ACNYourDetailsCompany : formValues.ABNYourDetailsCompany) : '',

    // Details of authorised/company representative completing this application
    RepresentativeGivenNames: formValues.isThirdPartyAuthorised ? formValues.GivenNamesYourDetailsThirdParty : (formValues.isDebtorTypeCompany ? formValues.GivenNamesYourDetailsCompany : ''),
    RepresentativeFamilyNameSurname: formValues.isThirdPartyAuthorised ? formValues.FamilyNameYourDetailsThirdParty : (formValues.isDebtorTypeCompany ? formValues.FamilyNameYourDetailsCompany : ''),
    PositionInCompany: formValues.isDebtorTypeCompany ? formValues.PositionInCompanyYourDetailsCompany : '',

      // Contact details
    AuthRepContactNumber: formValues.isThirdPartyAuthorised ? formValues.ContactNumberYourDetailsThirdParty.ContactNumber : (formValues.isDebtorTypeCompany ? formValues.ContactNumberYourDetailsCompany.ContactNumber : ''),
    AuthRepSendCorroTo: (formValues.isThirdPartyAuthorised && ((isSpecialCircumstance && (formValues.ReceiveApplicationViaEmailYourDetailsThirdParty === 'true')) || !isSpecialCircumstance) ? formValues.CorrespondenceRecipientYourDetailsThirdParty : ''),
    AuthRepOrgName: formValues.isThirdPartyAuthorised ? formValues.OrganisationNameYourDetailsThirdParty : '',
    AuthRepEmail: formValues.isThirdPartyAuthorised ? formValues.EmailYourDetailsThirdParty : (formValues.isDebtorTypeCompany ? formValues.EmailYourDetailsCompany : ''),
    AuthRepContactByEmail: (formValues.isThirdPartyAuthorised && !formValues.YesNoEmailYourDetailsThirdParty && formValues.ReceiveApplicationViaEmailYourDetailsThirdParty === 'true') ? 'Yes' : (formValues.isThirdPartyAuthorised && !formValues.YesNoEmailYourDetailsThirdParty && formValues.ReceiveApplicationViaEmailYourDetailsThirdParty === 'false' ? 'No' : ''),
    PositionrelationshipToApplicant: formValues.isThirdPartyAuthorised ? formValues.RelationshipWithNamedPersonYourDetailsThirdParty : '',

    // Reason for requesting a review
    ReviewGround: selectedGroundsMessageOptions.has(formValues.selectTheOption[0]) ? selectedGroundsMessageOptions.get(formValues.selectTheOption[0])! : '',

    // Special Circumstances ground(s) (if applicable)
    SpecialCircumstancesGround: formValues.selectTheSpecialOption.length > 0 && isSpecialCircumstance ? getSelectedSpecialCircumstances : '',
    WhenDidYouFindOutAboutTheFine: formValues.selectTheOption.includes('SelectedGroundInfo3') ? formValues.personUnawareFindOutDate ? `${(`0${formValues.personUnawareFindOutDate.getDate()}`).slice(-2)}/${(`0${formValues.personUnawareFindOutDate.getMonth() + 1}`).slice(-2)}/${formValues.personUnawareFindOutDate.getFullYear()}` : '' : '',

    // Why do you believe the fine(s) should be reviewed?
    WhyShouldFineBeReviewed: formValues.WhyYourFineShouldBeReviewed ? formValues.WhyYourFineShouldBeReviewed : '',

    // Supporting Material
    DocumentDescription: uploadedFileDescriptions,
    NumberOfAttachments: totalNumberOfAttachments.toString(),
    ATTACHMENTS: remoteAttachmentNames,
    // TODO - update TP to send to fineholder if client specfies
    EMAIL_TO: (formValues.isThirdPartyAuthorised && !formValues.YesNoEmailYourDetailsThirdParty && ((isSpecialCircumstance && formValues.ReceiveApplicationViaEmailYourDetailsThirdParty === 'true') || !isSpecialCircumstance)) ? formValues.EmailYourDetailsThirdParty : ((formValues.isDebtorTypeIndividual && !formValues.YesNoEmailYourDetailsIndividual && ((isSpecialCircumstance && formValues.ReceiveApplicationViaEmailYourDetailsIndividual === 'true') || !isSpecialCircumstance)) ? formValues.EmailYourDetailsIndividual : ((formValues.isDebtorTypeCompany && !formValues.YesNoEmailYourDetailsCompany) ? formValues.EmailYourDetailsCompany : '')),
    OBLIGATION_NUMBER: formValues.OBLIGATION_NUMBER,

    // Fines to include in this application
    FinesToInclude:
      formValues.isDebtorTypeIndividual && !formValues.isThirdPartyAuthorised
      ? getSelectedObsStep11
      : getSelectedObsStep12,

    // Declaration
    SignatureOfApplicant: formValues.ReviewConsentToDeclaration ? 'I agree with the statements' : '',
    DeclarationDate: `${DATE}/${MONTH}/${YEAR}`,

    // ##ER Individual PDF fields##
    TimeNeededToGetEvidence: formValues.isEnforcementReviewStage
    && (formValues.selectTheOption.includes('SelectedGroundInfo1') || isSpecialCircumstance)
    && formValues.IsMakingTimeRequest === 'true'
    ? formValues.TimeExtension
    : (formValues.isEnforcementReviewStage
      && (formValues.selectTheOption.includes('SelectedGroundInfo1') || isSpecialCircumstance)
      && formValues.IsMakingTimeRequest === 'false' ? 'No' : ''),

    // All Address fields across pdfs
      // ADDRESS 1 -  IR and ER
    LineOne:
    (formValues.isDebtorTypeCompany)
    ? formValues.DifferentToPostalYourDetailsCompany === 'true'
     ? formValues.StreetAddressYourDetailsCompany.LineOne
     : formValues.PostalAddressYourDetailsCompany.LineOne
    : (formValues.isEnforcementReviewStage
      ? formValues.isThirdPartyAuthorised
        ? formValues.DifferentToPostalFineholderDetails === 'true'
          ? formValues.ResidentialAddressFineholderDetails.LineOne
          : formValues.PostalAddressFineholderDetails.LineOne
        : formValues.isDebtorTypeIndividual
          ? formValues.DifferentToPostalYourDetailsIndividual === 'true'
            ? formValues.ResidentialAddressYourDetailsIndividual.LineOne
            : formValues.PostalAddressYourDetailsIndividual.LineOne
          : ''
      : ''),
      // (formValues.isThirdPartyAuthorised && formValues.DifferentToPostalFineholderDetails === 'true'
      //  ? formValues.ResidentialAddressFineholderDetails.LineOne
      //  : (formValues.DifferentToPostalYourDetailsIndividual === 'true'
      //    ? formValues.ResidentialAddressYourDetailsIndividual.LineOne
        //  : 'Indivodual Postal'))
      // : formValues.PostalAddressYourDetailsCompany.LineOne
      // ),
      LineTwo:
    (formValues.isDebtorTypeCompany)
    ? formValues.DifferentToPostalYourDetailsCompany === 'true'
     ? formValues.StreetAddressYourDetailsCompany.LineTwo
     : formValues.PostalAddressYourDetailsCompany.LineTwo
    : (formValues.isEnforcementReviewStage
      ? formValues.isThirdPartyAuthorised
        ? formValues.DifferentToPostalFineholderDetails === 'true'
          ? formValues.ResidentialAddressFineholderDetails.LineTwo
          : formValues.PostalAddressFineholderDetails.LineTwo
        : formValues.isDebtorTypeIndividual
          ? formValues.DifferentToPostalYourDetailsIndividual === 'true'
            ? formValues.ResidentialAddressYourDetailsIndividual.LineTwo
            : formValues.PostalAddressYourDetailsIndividual.LineTwo
          : ''
      : ''),
      Suburb:
    (formValues.isDebtorTypeCompany)
    ? formValues.DifferentToPostalYourDetailsCompany === 'true'
     ? formValues.StreetAddressYourDetailsCompany.Suburb
     : formValues.PostalAddressYourDetailsCompany.Suburb
    : (formValues.isEnforcementReviewStage
      ? formValues.isThirdPartyAuthorised
        ? formValues.DifferentToPostalFineholderDetails === 'true'
          ? formValues.ResidentialAddressFineholderDetails.Suburb
          : formValues.PostalAddressFineholderDetails.Suburb
        : formValues.isDebtorTypeIndividual
          ? formValues.DifferentToPostalYourDetailsIndividual === 'true'
            ? formValues.ResidentialAddressYourDetailsIndividual.Suburb
            : formValues.PostalAddressYourDetailsIndividual.Suburb
          : ''
      : ''),
      State:
    (formValues.isDebtorTypeCompany)
    ? formValues.DifferentToPostalYourDetailsCompany === 'true'
     ? formValues.StreetAddressYourDetailsCompany.State
     : formValues.PostalAddressYourDetailsCompany.State
    : (formValues.isEnforcementReviewStage
      ? formValues.isThirdPartyAuthorised
        ? formValues.DifferentToPostalFineholderDetails === 'true'
          ? formValues.ResidentialAddressFineholderDetails.State
          : formValues.PostalAddressFineholderDetails.State
        : formValues.isDebtorTypeIndividual
          ? formValues.DifferentToPostalYourDetailsIndividual === 'true'
            ? formValues.ResidentialAddressYourDetailsIndividual.State
            : formValues.PostalAddressYourDetailsIndividual.State
          : ''
      : ''),
      Postcode:
    (formValues.isDebtorTypeCompany)
    ? formValues.DifferentToPostalYourDetailsCompany === 'true'
     ? formValues.StreetAddressYourDetailsCompany.Postcode
     : formValues.PostalAddressYourDetailsCompany.Postcode
    : (formValues.isEnforcementReviewStage
      ? formValues.isThirdPartyAuthorised
        ? formValues.DifferentToPostalFineholderDetails === 'true'
          ? formValues.ResidentialAddressFineholderDetails.Postcode
          : formValues.PostalAddressFineholderDetails.Postcode
        : formValues.isDebtorTypeIndividual
          ? formValues.DifferentToPostalYourDetailsIndividual === 'true'
            ? formValues.ResidentialAddressYourDetailsIndividual.Postcode
            : formValues.PostalAddressYourDetailsIndividual.Postcode
          : ''
      : ''),
      Country:
    (formValues.isDebtorTypeCompany)
    ? formValues.DifferentToPostalYourDetailsCompany === 'true'
     ? formValues.StreetAddressYourDetailsCompany.Country
     : formValues.PostalAddressYourDetailsCompany.Country
    : (formValues.isEnforcementReviewStage
      ? formValues.isThirdPartyAuthorised
        ? formValues.DifferentToPostalFineholderDetails === 'true'
          ? formValues.ResidentialAddressFineholderDetails.Country
          : formValues.PostalAddressFineholderDetails.Country
        : formValues.isDebtorTypeIndividual
          ? formValues.DifferentToPostalYourDetailsIndividual === 'true'
            ? formValues.ResidentialAddressYourDetailsIndividual.Country
            : formValues.PostalAddressYourDetailsIndividual.Country
          : ''
      : ''),
    // LineTwo: (formValues.DifferentToPostalYourDetailsCompany === 'true' && formValues.isDebtorTypeCompany) ? formValues.StreetAddressYourDetailsCompany.LineTwo : (formValues.isEnforcementReviewStage ? (formValues.isThirdPartyAuthorised && formValues.DifferentToPostalFineholderDetails === 'true' ? formValues.ResidentialAddressFineholderDetails.LineTwo : (formValues.DifferentToPostalYourDetailsIndividual === 'true' ? formValues.ResidentialAddressYourDetailsIndividual.LineTwo : '')) : ''),
    // Suburb: (formValues.DifferentToPostalYourDetailsCompany === 'true' && formValues.isDebtorTypeCompany) ? formValues.StreetAddressYourDetailsCompany.Suburb : (formValues.isEnforcementReviewStage ? (formValues.isThirdPartyAuthorised && formValues.DifferentToPostalFineholderDetails === 'true' ? formValues.ResidentialAddressFineholderDetails.Suburb : (formValues.DifferentToPostalYourDetailsIndividual === 'true' ? formValues.ResidentialAddressYourDetailsIndividual.Suburb : '')) : ''),
    // State: (formValues.DifferentToPostalYourDetailsCompany === 'true' && formValues.isDebtorTypeCompany) ? formValues.StreetAddressYourDetailsCompany.State : (formValues.isEnforcementReviewStage ? (formValues.isThirdPartyAuthorised && formValues.DifferentToPostalFineholderDetails === 'true' ? formValues.ResidentialAddressFineholderDetails.State : (formValues.DifferentToPostalYourDetailsIndividual === 'true' ? formValues.ResidentialAddressYourDetailsIndividual.State : '')) : ''),
    // Postcode: (formValues.DifferentToPostalYourDetailsCompany === 'true' && formValues.isDebtorTypeCompany) ? formValues.StreetAddressYourDetailsCompany.Postcode : (formValues.isEnforcementReviewStage ? (formValues.isThirdPartyAuthorised && formValues.DifferentToPostalFineholderDetails === 'true' ? formValues.ResidentialAddressFineholderDetails.Postcode : (formValues.DifferentToPostalYourDetailsIndividual === 'true' ? formValues.ResidentialAddressYourDetailsIndividual.Postcode : '')) : ''),
    // Country: (formValues.DifferentToPostalYourDetailsCompany === 'true' && formValues.isDebtorTypeCompany) ? formValues.StreetAddressYourDetailsCompany.Country : (formValues.isEnforcementReviewStage ? (formValues.isThirdPartyAuthorised && formValues.DifferentToPostalFineholderDetails === 'true' ? formValues.ResidentialAddressFineholderDetails.Country : (formValues.DifferentToPostalYourDetailsIndividual === 'true' ? formValues.ResidentialAddressYourDetailsIndividual.Country : '')) : ''),
      // ADDRESS 2 - IR and ER -> (IR) Company Postal - (ER Third Party) Postal - (ER Individual) Postal - (ER Company) Company Postal
    LineOneTwo: formValues.isDebtorTypeCompany ? formValues.PostalAddressYourDetailsCompany.LineOne : (formValues.isEnforcementReviewStage ? (formValues.isThirdPartyAuthorised ? formValues.PostalAddressFineholderDetails.LineOne : formValues.PostalAddressYourDetailsIndividual.LineOne) : ''),
    LineTwoTwo: formValues.isDebtorTypeCompany ? formValues.PostalAddressYourDetailsCompany.LineTwo : (formValues.isEnforcementReviewStage ? (formValues.isThirdPartyAuthorised ? formValues.PostalAddressFineholderDetails.LineTwo : formValues.PostalAddressYourDetailsIndividual.LineTwo) : ''),
    SuburbTwo: formValues.isDebtorTypeCompany ? formValues.PostalAddressYourDetailsCompany.Suburb : (formValues.isEnforcementReviewStage ? (formValues.isThirdPartyAuthorised ? formValues.PostalAddressFineholderDetails.Suburb : formValues.PostalAddressYourDetailsIndividual.Suburb) : ''),
    StateTwo: formValues.isDebtorTypeCompany ? formValues.PostalAddressYourDetailsCompany.State : (formValues.isEnforcementReviewStage ? (formValues.isThirdPartyAuthorised ? formValues.PostalAddressFineholderDetails.State : formValues.PostalAddressYourDetailsIndividual.State) : ''),
    PostcodeTwo: formValues.isDebtorTypeCompany ? formValues.PostalAddressYourDetailsCompany.Postcode : (formValues.isEnforcementReviewStage ? (formValues.isThirdPartyAuthorised ? formValues.PostalAddressFineholderDetails.Postcode : formValues.PostalAddressYourDetailsIndividual.Postcode) : ''),
    CountryTwo: formValues.isDebtorTypeCompany ? formValues.PostalAddressYourDetailsCompany.Country : (formValues.isEnforcementReviewStage ? (formValues.isThirdPartyAuthorised ? formValues.PostalAddressFineholderDetails.Country : formValues.PostalAddressYourDetailsIndividual.Country) : ''),
      // ADDRESS 3 - IR
    LineOneThree: formValues.isInternalReviewStage
    ? ((formValues.isThirdPartyAuthorised)
      ? formValues.DifferentToPostalFineholderDetails === 'true'
       ? formValues.ResidentialAddressFineholderDetails.LineOne
       : formValues.PostalAddressFineholderDetails.LineOne
     : (formValues.isDebtorTypeIndividual
      ? !formValues.isThirdPartyAuthorised && formValues.DifferentToPostalYourDetailsIndividual === 'true'
        ? formValues.ResidentialAddressYourDetailsIndividual.LineOne
        : formValues.PostalAddressYourDetailsIndividual.LineOne
      : ''))
    : '',
    LineTwoThree: formValues.isInternalReviewStage
    ? ((formValues.isThirdPartyAuthorised)
      ? formValues.DifferentToPostalFineholderDetails === 'true'
       ? formValues.ResidentialAddressFineholderDetails.LineTwo
       : formValues.PostalAddressFineholderDetails.LineTwo
     : (formValues.isDebtorTypeIndividual
      ? !formValues.isThirdPartyAuthorised && formValues.DifferentToPostalYourDetailsIndividual === 'true'
        ? formValues.ResidentialAddressYourDetailsIndividual.LineTwo
        : formValues.PostalAddressYourDetailsIndividual.LineTwo
      : ''))
    : '',
    SuburbThree: formValues.isInternalReviewStage
    ? ((formValues.isThirdPartyAuthorised)
      ? formValues.DifferentToPostalFineholderDetails === 'true'
       ? formValues.ResidentialAddressFineholderDetails.Suburb
       : formValues.PostalAddressFineholderDetails.Suburb
     : (formValues.isDebtorTypeIndividual
      ? !formValues.isThirdPartyAuthorised && formValues.DifferentToPostalYourDetailsIndividual === 'true'
        ? formValues.ResidentialAddressYourDetailsIndividual.Suburb
        : formValues.PostalAddressYourDetailsIndividual.Suburb
      : ''))
    : '',
    PostcodeThree: formValues.isInternalReviewStage
    ? ((formValues.isThirdPartyAuthorised)
      ? formValues.DifferentToPostalFineholderDetails === 'true'
       ? formValues.ResidentialAddressFineholderDetails.Postcode
       : formValues.PostalAddressFineholderDetails.Postcode
     : (formValues.isDebtorTypeIndividual
      ? !formValues.isThirdPartyAuthorised && formValues.DifferentToPostalYourDetailsIndividual === 'true'
        ? formValues.ResidentialAddressYourDetailsIndividual.Postcode
        : formValues.PostalAddressYourDetailsIndividual.Postcode
      : ''))
    : '',
    StateThree: formValues.isInternalReviewStage
    ? ((formValues.isThirdPartyAuthorised)
      ? formValues.DifferentToPostalFineholderDetails === 'true'
       ? formValues.ResidentialAddressFineholderDetails.State
       : formValues.PostalAddressFineholderDetails.State
     : (formValues.isDebtorTypeIndividual
      ? !formValues.isThirdPartyAuthorised && formValues.DifferentToPostalYourDetailsIndividual === 'true'
        ? formValues.ResidentialAddressYourDetailsIndividual.State
        : formValues.PostalAddressYourDetailsIndividual.State
      : ''))
    : '',
    CountryThree: formValues.isInternalReviewStage
    ? ((formValues.isThirdPartyAuthorised)
      ? formValues.DifferentToPostalFineholderDetails === 'true'
       ? formValues.ResidentialAddressFineholderDetails.Country
       : formValues.PostalAddressFineholderDetails.Country
     : (formValues.isDebtorTypeIndividual
      ? !formValues.isThirdPartyAuthorised && formValues.DifferentToPostalYourDetailsIndividual === 'true'
        ? formValues.ResidentialAddressYourDetailsIndividual.Country
        : formValues.PostalAddressYourDetailsIndividual.Country
      : ''))
    : '',
    // LineTwoThree: formValues.isInternalReviewStage ? ((formValues.isThirdPartyAuthorised && formValues.DifferentToPostalFineholderDetails === 'true') ? formValues.ResidentialAddressFineholderDetails.LineTwo : (formValues.isDebtorTypeIndividual && !formValues.isThirdPartyAuthorised && formValues.DifferentToPostalYourDetailsIndividual === 'true' ? formValues.ResidentialAddressYourDetailsIndividual.LineTwo : formValues.PostalAddressYourDetailsIndividual.LineTwo)) : '',
    // SuburbThree: formValues.isInternalReviewStage ? ((formValues.isThirdPartyAuthorised && formValues.DifferentToPostalFineholderDetails === 'true') ? formValues.ResidentialAddressFineholderDetails.Suburb : (formValues.isDebtorTypeIndividual && !formValues.isThirdPartyAuthorised && formValues.DifferentToPostalYourDetailsIndividual === 'true' ? formValues.ResidentialAddressYourDetailsIndividual.Suburb : formValues.PostalAddressYourDetailsIndividual.Suburb)) : '',
    // StateThree: formValues.isInternalReviewStage ? ((formValues.isThirdPartyAuthorised && formValues.DifferentToPostalFineholderDetails === 'true') ? formValues.ResidentialAddressFineholderDetails.State : (formValues.isDebtorTypeIndividual && !formValues.isThirdPartyAuthorised && formValues.DifferentToPostalYourDetailsIndividual === 'true' ? formValues.ResidentialAddressYourDetailsIndividual.State : formValues.PostalAddressYourDetailsIndividual.State)) : '',
    // PostcodeThree: formValues.isInternalReviewStage ? ((formValues.isThirdPartyAuthorised && formValues.DifferentToPostalFineholderDetails === 'true') ? formValues.ResidentialAddressFineholderDetails.Postcode : (formValues.isDebtorTypeIndividual && !formValues.isThirdPartyAuthorised && formValues.DifferentToPostalYourDetailsIndividual === 'true' ? formValues.ResidentialAddressYourDetailsIndividual.Postcode : formValues.PostalAddressYourDetailsIndividual.Postcode)) : '',
    // CountryThree: formValues.isInternalReviewStage ? ((formValues.isThirdPartyAuthorised && formValues.DifferentToPostalFineholderDetails === 'true') ? formValues.ResidentialAddressFineholderDetails.Country : (formValues.isDebtorTypeIndividual && !formValues.isThirdPartyAuthorised && formValues.DifferentToPostalYourDetailsIndividual === 'true' ? formValues.ResidentialAddressYourDetailsIndividual.Country : formValues.PostalAddressYourDetailsIndividual.Country)) : '',
     // ADDRESS 4 - IR
    LineOneFour: formValues.isInternalReviewStage ? (formValues.isThirdPartyAuthorised ? formValues.PostalAddressFineholderDetails.LineOne : (formValues.isDebtorTypeIndividual ? formValues.PostalAddressYourDetailsIndividual.LineOne : '')) : formValues.isThirdPartyAuthorised ? formValues.PostalAddressYourDetailsThirdParty.LineOne : '',
    LineTwoFour: formValues.isInternalReviewStage ? (formValues.isThirdPartyAuthorised ? formValues.PostalAddressFineholderDetails.LineTwo : (formValues.isDebtorTypeIndividual ? formValues.PostalAddressYourDetailsIndividual.LineTwo : '')) : formValues.isThirdPartyAuthorised ? formValues.PostalAddressYourDetailsThirdParty.LineTwo : '',
    SuburbFour: formValues.isInternalReviewStage ? (formValues.isThirdPartyAuthorised ? formValues.PostalAddressFineholderDetails.Suburb : (formValues.isDebtorTypeIndividual ? formValues.PostalAddressYourDetailsIndividual.Suburb : '')) : formValues.isThirdPartyAuthorised ? formValues.PostalAddressYourDetailsThirdParty.Suburb : '',
    StateFour: formValues.isInternalReviewStage ? (formValues.isThirdPartyAuthorised ? formValues.PostalAddressFineholderDetails.State : (formValues.isDebtorTypeIndividual ? formValues.PostalAddressYourDetailsIndividual.State : '')) : formValues.isThirdPartyAuthorised ? formValues.PostalAddressYourDetailsThirdParty.State : '',
    PostcodeFour: formValues.isInternalReviewStage ? (formValues.isThirdPartyAuthorised ? formValues.PostalAddressFineholderDetails.Postcode : (formValues.isDebtorTypeIndividual ? formValues.PostalAddressYourDetailsIndividual.Postcode : '')) : formValues.isThirdPartyAuthorised ? formValues.PostalAddressYourDetailsThirdParty.Postcode : '',
    CountryFour: formValues.isInternalReviewStage ? (formValues.isThirdPartyAuthorised ? formValues.PostalAddressFineholderDetails.Country : (formValues.isDebtorTypeIndividual ? formValues.PostalAddressYourDetailsIndividual.Country : '')) : formValues.isThirdPartyAuthorised ? formValues.PostalAddressYourDetailsThirdParty.Country : '',
      // ADDRESS 5 - IR
    LineOneFive: formValues.isInternalReviewStage ? (formValues.isThirdPartyAuthorised ? formValues.PostalAddressYourDetailsThirdParty.LineOne : '') : '',
    LineTwoFive: formValues.isInternalReviewStage ? (formValues.isThirdPartyAuthorised ? formValues.PostalAddressYourDetailsThirdParty.LineTwo : '') : '',
    SuburbFive: formValues.isInternalReviewStage ? (formValues.isThirdPartyAuthorised ? formValues.PostalAddressYourDetailsThirdParty.Suburb : '') : '',
    StateFive: formValues.isInternalReviewStage ? (formValues.isThirdPartyAuthorised ? formValues.PostalAddressYourDetailsThirdParty.State : '') : '',
    PostcodeFive: formValues.isInternalReviewStage ? (formValues.isThirdPartyAuthorised ? formValues.PostalAddressYourDetailsThirdParty.Postcode : '') : '',
    CountryFive: formValues.isInternalReviewStage ? (formValues.isThirdPartyAuthorised ? formValues.PostalAddressYourDetailsThirdParty.Country : '') : '',

    // Footer Pg 1
    FooterSubmissionNo1: submissionNumber,
    FooterFormType1: FORM_TYPE,
    FooterObligationNo1: formValues.OBLIGATION_NUMBER,
    FooterSubmissionTime1: SUBMITTED_TIME,
    // Footer Pg 2
    FooterSubmissionNo2: submissionNumber,
    FooterFormType2: FORM_TYPE,
    FooterObligationNo2: formValues.OBLIGATION_NUMBER,
    FooterSubmissionTime2: SUBMITTED_TIME,
    // Footer Pg 3
    FooterSubmissionNo3: submissionNumber,
    FooterFormType3: FORM_TYPE,
    FooterObligationNo3: formValues.OBLIGATION_NUMBER,
    FooterSubmissionTime3: SUBMITTED_TIME,
    // Footer Pg 4
    FooterSubmissionNo4: submissionNumber,
    FooterFormType4: FORM_TYPE,
    FooterObligationNo4: formValues.OBLIGATION_NUMBER,
    FooterSubmissionTime4: SUBMITTED_TIME,
  };
  const excludeKeysFromForm: string[] = [
    'a',
    'ABNYourDetailsCompany',
    'ACNYourDetailsCompany',
    'AbnAcnTypeYourDetailsCompany',
    'ApplyingForPenaltyReminder',
    'areThereAnyAdditionalFines',
    'Attachments',
    'AuthorisedObligation',
    'CanSave',
    'closeTheOption',
    'CheckAndConfirmPageLoaded',
    'CompanyNameYourDetailsCompany',
    'ContactNumberFineholderDetails',
    'ContactNumberYourDetailsCompany',
    'ContactNumberYourDetailsIndividual',
    'ContactNumberYourDetailsThirdParty',
    'contraryToLawCanUploadSupportingDocs',
    'contraryToLawWasLegalMistakeMade',
    'CorrespondenceRecipientYourDetailsThirdParty',
    'CreateDate',
    'DebtorID',
    'DebtorType',
    'DOB',
    'DOBFineholderDetails',
    'DOBYourDetailsIndividual',
    'DOBRequired',
    'DRIVER_LICENCE',
    'DifferentToPostalFineholderDetails',
    'DifferentToPostalYourDetailsIndividual',
    'DifferentToPostalYourDetailsCompany',
    'EligibleObligations',
    'EMRemeinderSent',
    'EmailFineholderDetails',
    'EmailYourDetailsCompany',
    'EmailYourDetailsIndividual',
    'EmailYourDetailsThirdParty',
    'errorOrInfoAppearsInAccordion',
    'exceptionalsCanUploadSupportingDocs',
    'ExpiryDate',
    'FamilyNameFineholderDetails',
    'FamilyNameYourDetailsCompany',
    'FamilyNameYourDetailsIndividual',
    'FamilyNameYourDetailsThirdParty',
    'FormExperience',
    'FormTypeID',
    'FileUploadDescriptionConfig',
    'FileUploadMaxAttachmentsConfig',
    'FileUploadSizeConfig',
    'FormData',
    'GivenNamesFineholderDetails',
    'GivenNamesYourDetailsCompany',
    'GivenNamesYourDetailsIndividual',
    'GivenNamesYourDetailsThirdParty',
    'HEARING_DATE',
    'HasStatementAndEvidenceSupportingDocs',
    'HaveYouSubmittedEnforcementReviewBefore',
    'HearingDateRequired',
    'ID',
    'InfringementNumber',
    'IsMakingTimeRequest',
    'isPUEligible',
    'IsSubscribedEM',
    'IsSubscribedSMS',
    'isDebtorTypeCompany',
    'isDebtorTypeIndividual',
    'isEnforcementReviewStage',
    'isInternalReviewStage',
    'isNominatable',
    'isThePersonNamed',
    'isThirdPartyAuthorised',
    'LicenceRequired',
    'mistakeOfIdentityCanUploadSupportingDocs',
    'mistakeOfIndentityWasSomeoneElseDriving',
    'NumberOfInvalidPersonUnaware',
    'NumberOfValidEnforcementReview',
    'NumberOfValidInternalReview',
    'NumberOfInvalidSevenDayNotice',
    'NumberOfInvalidSevenDayNotice',
    'OffenceCode',
    'OffenceDateRequired',
    'OFFENCE_DATE',
    'ObligationStatus',
    'Obligations',
    'obligationNumberToIncludeStep12',
    'OrganisationNameYourDetailsThirdParty',
    'PartialFormID',
    'PlaceOfIssueFineholderDetails',
    'PlaceOfIssueYourDetailsIndividual',
    'PositionInCompanyYourDetailsCompany',
    'PostalAddressFineholderDetails',
    'PostalAddressYourDetailsCompany',
    'PostalAddressYourDetailsIndividual',
    'PostalAddressYourDetailsThirdParty',
    'personUnawareCanUploadSupportingDocs',
    'personUnawareEnforcementHappened',
    'personUnawareFindOutDate',
    'personUnawareWasSomeoneElseDriving',
    'PersonUnawareIneligibleList',
    'ReceiveApplicationViaEmailYourDetailsIndividual',
    'ReceiveApplicationViaEmailYourDetailsThirdParty',
    'ReceiveCorrespondenceViaEmailYourDetailsIndividual',
    'RegistrationRequired',
    'RelationshipWithNamedPersonYourDetailsThirdParty',
    'ResidentialAddressFineholderDetails',
    'ResidentialAddressYourDetailsIndividual',
    'ReviewConsentToDeclaration',
    'reviewGroundsList',
    'SMSRemeinderSent',
    'SaveOptions',
    'SaveYesNo',
    'SelectedGroundInfo',
    'SelectedObligationsStep11',
    'SelectedObligationsStep12',
    'SelectedSpecialsGroundInfo',
    'StateOfIssueFineholderDetails',
    'StateOfIssueYourDetailsIndividual',
    'StatementAndEvidence',
    'StatementAndEvidenceDescription',
    'StatementAndEvidenceFileSectionError',
    'StatementAndEvidenceFileUploadErrorHandle',
    'StatementAndEvidenceNameField',
    'StatementAndEvidenceProvider',
    'StatementAndEvidenceSizeErrorHandle',
    'Status',
    'StreetAddressYourDetailsCompany',
    'saveEmail',
    'saveMobile',
    'selectTheOption',
    'selectTheSpecialOption',
    'specialsCanUploadSupportingDocs',
    'submitted',
    'submissionError',
    'TicketType',
    'TimeExtension',
    'VEHICLE_REGISTRATION',
    'WasSomeoneElseDrivingAtTimeOfOffence',
    'WhyYourFineShouldBeReviewed',
    'wasThereAnIdentificationMistake',
    'wereThereExceptionalCircumstances',
    'wereThereSpecialCircumstances',
    'YesNoDriverLicenceFineholderDetails',
    'YesNoDriverLicenceYourDetailsIndividual',
    'YesNoEmailFineholderDetails',
    'YesNoEmailYourDetailsCompany',
    'YesNoEmailYourDetailsIndividual',
    'YesNoEmailYourDetailsThirdParty',
    'isABNValidYourDetails',
    'isACNValidYourDetails',
    'ContactNumberFineholderDetailsMessage',
    'EmailFineholderDetailsMessage',
    'ContactNumberYourDetailsIndividualWarning',
    'EmailYourDetailsIndividualWarning',
    'ContactNumberYourDetailsThirdPartyWarning',
    'EmailYourDetailsThirdPartyWarning',
    'ContactNumberYourDetailsCompanyWarning',
    'EmailYourDetailsCompanyWarning',
  ];
  excludeKeysFromForm.forEach((value: string) => {
    delete submitObject[value];
  });
  return submitObject;
};
